import profile from "./profile.png";
import p1_review1_1 from "./p1_review1_1.jpg";
import p1_review1_2 from "./p1_review1_2.jpg";
import p1_review1_3 from "./p1_review1_3.jpg";
import p1_review1_4 from "./p1_review1_4.jpg";
import p1_review2_1 from "./p1_review2_1.jpg";
import p1_review3_1 from "./p1_review3_1.jpg";
import p1_review3_2 from "./p1_review3_2.jpg";
import p1_review3_3 from "./p1_review3_3.jpg";

let reviews = [
  {
    id: 1,
    productId: 1,
    profile_image: profile,
    userName: "Lochlann O Neill",
    userHandle: "@lochlannoneill",
    rating: 5,
    summary: "This is an absolutely amazing product!",
    date: "2022-02-22",
    time: "17:40:22",
    verified: true,
    images: [p1_review1_1, p1_review1_2, p1_review1_3, p1_review1_4],
    description: "Wow, this top is one of the softest tops I've ever owned, it really feels so lovely on.It's quite lightweight so won't keep you very warm but is stylish,I love the unusual sleeves however, I'm quite tall (5'9), and found the sleeves short.For reference I wear a 10-12 in tops but got the S as didn't want it to be too baggy, there is loads of stretch so I'm happy with the size, actually wish it was a bit more slim fitting.",
    helpful: ["user1_id", "user2_id", "user3_id", "user4_id", "user5_id", "user6_id", "user7_id", "user8_id", "user9_id", "user10_id", "user11_id"]
  },
  {
    id: 2,
    productId: 1,
    userName: "Jane Smith",
    userHandle: "@janesmith",
    rating: 3,
    summary: "93% Cotton, fits nicely",
    date: "2024-03-26",
    time: "13:00:00",
    verified: false,
    images: [p1_review3_1, p1_review3_2, p1_review3_3],
    description: "Casual fit and style, 93% cotton and 7% spandex. (Not to tumble dry). Size fitted well on family members wearing L. Simple but nice looking long sleeve V Top. Nothing special but does the job.",
    helpful: []
  },
  {
    id: 3,
    productId: 1,
    userName: "John Doe",
    userHandle: "@johndoe",
    rating: 4,
    summary: "Great for the autumn",
    date: "2024-03-26",
    time: "14:00:00",
    verified: false,
    images: [p1_review2_1],
    description: "This jumper is lovely and soft and feels warm when worn without being too bulky. It can be worn on smart casual occasions and it looks stylish with the button detail on the v neckline it has a slight ribbed effect. I found the sleeve length perfect and body length was not too long just sat nicely on my hips. I got the black which looked smart worn with black trousers or jeans and the size s fitted very well I'm usually a size 10 . I would consider buying in a different colour as there is a good selection.",
    helpful: ["user1_id"]
  },
  {
    id: 4,
    productId: 1,
    userName: "Jane Doe",
    userHandle: "@janedoe",
    rating: 4,
    summary: "Good product",
    date: "2024-03-26",
    time: "11:00:00",
    verified: true,
    images: [],
    description: "Tbh I didn't have desperately high expectations but this top is nice. It's soft, long and just looks nice, sits well with a v-neck t shirt underneath just visible. Plus it's a bit different, I haven't seen anything similar in the shops.",
    helpful: []
  },
  {
    id: 5,
    productId: 1,
    userName: "John Smith",
    userHandle: "@johnsmith",
    rating: 2,
    summary: "Too short for me",
    date: "2024-03-26",
    time: "12:00:00",
    verified: false,
    images: [],
    description: "Loved the design but it barely reaches my hips at 5'4. I don't want to go larger as the fit is otherwise good. Wish they made a longer version because the material and look are lovely.",
    helpful: ["user1_id", "user2_id", "user3_id"]
  },
  {
    id: 6,
    productId: 2,
    userName: "Emily Clarke",
    userHandle: "@emilyclarke",
    rating: 4,
    summary: "Really nice, one small issue",
    date: "2025-11-10",
    time: "10:37:04",
    verified: false,
    images: [],
    description: "Overall a great purchase. The fabric is lovely and soft, sits nicely on the body. Only giving 4 stars because the sleeves are slightly shorter than I expected. I'm 5'7 and they sit just above my wrist. Otherwise perfect.",
    helpful: ["user1_id", "user2_id", "user3_id", "user4_id", "user5_id"]
  },
  {
    id: 7,
    productId: 2,
    userName: "Sean Murphy",
    userHandle: "@seanmurphy",
    rating: 4,
    summary: "Great for everyday wear",
    date: "2024-03-25",
    time: "11:22:02",
    verified: true,
    images: [],
    description: "Comfortable, stylish and easy to throw on. Works well with jeans or dressed up with a skirt. The material is decent quality and holds its shape well. Would be 5 stars if there were more colour options.",
    helpful: []
  },
  {
    id: 8,
    productId: 2,
    userName: "Aoife Byrne",
    userHandle: "@aoifebyrne",
    rating: 2,
    summary: "Disappointed with the sizing",
    date: "2023-12-13",
    time: "11:14:29",
    verified: false,
    images: [],
    description: "I usually wear a medium and ordered my usual size but this runs really small. Had to return and size up. The fabric also isn't as thick as the photos suggest. Not great for the price.",
    helpful: []
  },
  {
    id: 9,
    productId: 2,
    userName: "Ciaran Kelly",
    userHandle: "@ciarankelly",
    rating: 5,
    summary: "Absolutely love this!",
    date: "2025-06-28",
    time: "11:45:12",
    verified: true,
    images: [],
    description: "The quality is incredible for the price. It's so soft against my skin and the colour hasn't faded after multiple washes. I've already ordered a second one in a different colour. True to size and flattering on.",
    helpful: []
  },
  {
    id: 10,
    productId: 2,
    userName: "Niamh Walsh",
    userHandle: "@niamhwalsh",
    rating: 3,
    summary: "Average quality",
    date: "2024-01-17",
    time: "18:48:26",
    verified: false,
    images: [],
    description: "Expected a bit more honestly. The fabric feels a bit thin and I worry it might pill after a few washes. The colour is nice though and it's comfortable to wear. Might return and try a different brand.",
    helpful: []
  },
  {
    id: 11,
    productId: 3,
    userName: "Declan Ryan",
    userHandle: "@declanryan",
    rating: 2,
    summary: "Disappointed with the sizing",
    date: "2025-12-20",
    time: "15:39:59",
    verified: true,
    images: [],
    description: "I usually wear a medium and ordered my usual size but this runs really small. Had to return and size up. The fabric also isn't as thick as the photos suggest. Not great for the price.",
    helpful: ["user1_id", "user2_id", "user3_id", "user4_id"]
  },
  {
    id: 12,
    productId: 3,
    userName: "Siobhan O'Brien",
    userHandle: "@siobhanobrien",
    rating: 4,
    summary: "Great for everyday wear",
    date: "2025-03-12",
    time: "20:43:12",
    verified: false,
    images: [],
    description: "Comfortable, stylish and easy to throw on. Works well with jeans or dressed up with a skirt. The material is decent quality and holds its shape well. Would be 5 stars if there were more colour options.",
    helpful: []
  },
  {
    id: 13,
    productId: 3,
    userName: "Padraig Doyle",
    userHandle: "@padraigdoyle",
    rating: 1,
    summary: "Very poor quality",
    date: "2026-02-27",
    time: "14:30:27",
    verified: true,
    images: [],
    description: "Started pilling after the first wash. The seams are already coming loose after just two wears. Really disappointed as I had high hopes based on the photos. Would not recommend.",
    helpful: ["user1_id", "user2_id", "user3_id", "user4_id"]
  },
  {
    id: 14,
    productId: 3,
    userName: "Roisin Gallagher",
    userHandle: "@roisingallagher",
    rating: 5,
    summary: "Beautiful quality",
    date: "2025-10-26",
    time: "20:50:21",
    verified: false,
    images: [],
    description: "Really impressed with this. The knit is dense and feels premium. I was worried it might be see-through but it's not at all. Perfect weight for layering or wearing on its own. Fits perfectly.",
    helpful: ["user1_id", "user2_id", "user3_id", "user4_id", "user5_id", "user6_id"]
  },
  {
    id: 15,
    productId: 3,
    userName: "Conor Fitzgerald",
    userHandle: "@conorfitzgerald",
    rating: 1,
    summary: "Very poor quality",
    date: "2025-04-13",
    time: "09:39:08",
    verified: false,
    images: [],
    description: "Started pilling after the first wash. The seams are already coming loose after just two wears. Really disappointed as I had high hopes based on the photos. Would not recommend.",
    helpful: []
  },
  {
    id: 16,
    productId: 3,
    userName: "Saoirse Brennan",
    userHandle: "@saoirsebrennan",
    rating: 2,
    summary: "Disappointed with the sizing",
    date: "2025-04-26",
    time: "09:27:43",
    verified: false,
    images: [],
    description: "I usually wear a medium and ordered my usual size but this runs really small. Had to return and size up. The fabric also isn't as thick as the photos suggest. Not great for the price.",
    helpful: ["user1_id", "user2_id", "user3_id"]
  },
  {
    id: 17,
    productId: 4,
    userName: "Eoin McCarthy",
    userHandle: "@eoinmccarthy",
    rating: 2,
    summary: "Disappointed with the sizing",
    date: "2025-07-19",
    time: "19:07:32",
    verified: false,
    images: [],
    description: "I usually wear a medium and ordered my usual size but this runs really small. Had to return and size up. The fabric also isn't as thick as the photos suggest. Not great for the price.",
    helpful: ["user1_id", "user2_id", "user3_id", "user4_id"]
  },
  {
    id: 18,
    productId: 4,
    userName: "Caoimhe Nolan",
    userHandle: "@caoimhenolan",
    rating: 3,
    summary: "Decent but nothing special",
    date: "2025-06-24",
    time: "14:37:47",
    verified: true,
    images: [],
    description: "It's fine for the price. The material is okay but not as soft as I was hoping. The fit is a bit boxy on me but that might just be my body shape. It does the job for casual days.",
    helpful: ["user1_id", "user2_id"]
  },
  {
    id: 19,
    productId: 4,
    userName: "Oisin Kavanagh",
    userHandle: "@oisinkavanagh",
    rating: 5,
    summary: "My new favourite top",
    date: "2025-02-09",
    time: "21:20:24",
    verified: true,
    images: [],
    description: "I wear this constantly. It goes with everything in my wardrobe and is comfortable enough for all day wear. The fabric has a lovely drape and doesn't cling in unflattering places. Highly recommend.",
    helpful: ["user1_id", "user2_id", "user3_id", "user4_id", "user5_id", "user6_id", "user7_id"]
  },
  {
    id: 20,
    productId: 4,
    userName: "Maeve Dunne",
    userHandle: "@maevedunne",
    rating: 2,
    summary: "Not what I expected",
    date: "2024-12-16",
    time: "10:21:40",
    verified: true,
    images: [],
    description: "The colour online looked much richer than what arrived. It's quite washed out in person. The stitching around the neckline is also a bit loose. Might just be a bad batch but I'm not impressed.",
    helpful: []
  },
  {
    id: 21,
    productId: 4,
    userName: "Cillian Power",
    userHandle: "@cillianpower",
    rating: 4,
    summary: "Really nice, one small issue",
    date: "2023-10-05",
    time: "17:51:55",
    verified: true,
    images: [],
    description: "Overall a great purchase. The fabric is lovely and soft, sits nicely on the body. Only giving 4 stars because the sleeves are slightly shorter than I expected. I'm 5'7 and they sit just above my wrist. Otherwise perfect.",
    helpful: []
  },
  {
    id: 22,
    productId: 4,
    userName: "Fiona Healy",
    userHandle: "@fionahealy",
    rating: 4,
    summary: "Pleased with this purchase",
    date: "2023-08-08",
    time: "17:47:21",
    verified: true,
    images: [],
    description: "Bought this on a whim and I'm glad I did. It's well made and the fit is flattering without being too tight. The colour is exactly as shown in the photos. A solid wardrobe staple.",
    helpful: ["user1_id", "user2_id", "user3_id", "user4_id", "user5_id", "user6_id"]
  },
  {
    id: 23,
    productId: 5,
    userName: "Liam Daly",
    userHandle: "@liamdaly",
    rating: 2,
    summary: "Not what I expected",
    date: "2026-01-28",
    time: "14:18:15",
    verified: true,
    images: [],
    description: "The colour online looked much richer than what arrived. It's quite washed out in person. The stitching around the neckline is also a bit loose. Might just be a bad batch but I'm not impressed.",
    helpful: []
  },
  {
    id: 24,
    productId: 5,
    userName: "Orla Quinn",
    userHandle: "@orlaquinn",
    rating: 4,
    summary: "Pleased with this purchase",
    date: "2025-01-07",
    time: "14:43:00",
    verified: false,
    images: [],
    description: "Bought this on a whim and I'm glad I did. It's well made and the fit is flattering without being too tight. The colour is exactly as shown in the photos. A solid wardrobe staple.",
    helpful: []
  },
  {
    id: 25,
    productId: 5,
    userName: "Darragh Keane",
    userHandle: "@darraghkeane",
    rating: 4,
    summary: "Great for everyday wear",
    date: "2024-07-06",
    time: "09:50:48",
    verified: false,
    images: [],
    description: "Comfortable, stylish and easy to throw on. Works well with jeans or dressed up with a skirt. The material is decent quality and holds its shape well. Would be 5 stars if there were more colour options.",
    helpful: ["user1_id", "user2_id", "user3_id", "user4_id", "user5_id", "user6_id"]
  },
  {
    id: 26,
    productId: 6,
    userName: "Aine Reilly",
    userHandle: "@ainereilly",
    rating: 3,
    summary: "Decent but nothing special",
    date: "2025-11-05",
    time: "17:20:47",
    verified: false,
    images: [],
    description: "It's fine for the price. The material is okay but not as soft as I was hoping. The fit is a bit boxy on me but that might just be my body shape. It does the job for casual days.",
    helpful: []
  },
  {
    id: 27,
    productId: 6,
    userName: "Cathal Moran",
    userHandle: "@cathalmoran",
    rating: 4,
    summary: "Really nice, one small issue",
    date: "2025-07-20",
    time: "14:23:26",
    verified: false,
    images: [],
    description: "Overall a great purchase. The fabric is lovely and soft, sits nicely on the body. Only giving 4 stars because the sleeves are slightly shorter than I expected. I'm 5'7 and they sit just above my wrist. Otherwise perfect.",
    helpful: ["user1_id", "user2_id", "user3_id"]
  },
  {
    id: 28,
    productId: 6,
    userName: "Grainne Farrell",
    userHandle: "@grainnefarrell",
    rating: 4,
    summary: "Really nice, one small issue",
    date: "2023-11-01",
    time: "14:35:29",
    verified: false,
    images: [],
    description: "Overall a great purchase. The fabric is lovely and soft, sits nicely on the body. Only giving 4 stars because the sleeves are slightly shorter than I expected. I'm 5'7 and they sit just above my wrist. Otherwise perfect.",
    helpful: ["user1_id", "user2_id", "user3_id", "user4_id", "user5_id", "user6_id", "user7_id"]
  },
  {
    id: 29,
    productId: 7,
    userName: "Tadhg Lynch",
    userHandle: "@tadhglynch",
    rating: 3,
    summary: "Average quality",
    date: "2025-08-24",
    time: "18:45:15",
    verified: true,
    images: [],
    description: "Expected a bit more honestly. The fabric feels a bit thin and I worry it might pill after a few washes. The colour is nice though and it's comfortable to wear. Might return and try a different brand.",
    helpful: ["user1_id", "user2_id"]
  },
  {
    id: 30,
    productId: 7,
    userName: "Clodagh Murray",
    userHandle: "@clodaghmurray",
    rating: 2,
    summary: "Not what I expected",
    date: "2025-07-02",
    time: "13:58:20",
    verified: false,
    images: [],
    description: "The colour online looked much richer than what arrived. It's quite washed out in person. The stitching around the neckline is also a bit loose. Might just be a bad batch but I'm not impressed.",
    helpful: ["user1_id", "user2_id", "user3_id", "user4_id", "user5_id", "user6_id", "user7_id"]
  },
  {
    id: 31,
    productId: 7,
    userName: "Ronan Smyth",
    userHandle: "@ronansmyth",
    rating: 5,
    summary: "My new favourite top",
    date: "2023-11-19",
    time: "11:25:18",
    verified: true,
    images: [],
    description: "I wear this constantly. It goes with everything in my wardrobe and is comfortable enough for all day wear. The fabric has a lovely drape and doesn't cling in unflattering places. Highly recommend.",
    helpful: ["user1_id", "user2_id", "user3_id", "user4_id"]
  },
  {
    id: 32,
    productId: 9,
    userName: "Sinead Burke",
    userHandle: "@sineadburke",
    rating: 4,
    summary: "Great for everyday wear",
    date: "2025-07-11",
    time: "10:01:03",
    verified: true,
    images: [],
    description: "Comfortable, stylish and easy to throw on. Works well with jeans or dressed up with a skirt. The material is decent quality and holds its shape well. Would be 5 stars if there were more colour options.",
    helpful: []
  },
  {
    id: 33,
    productId: 9,
    userName: "Fergal O'Sullivan",
    userHandle: "@fergalosullivan",
    rating: 2,
    summary: "Not what I expected",
    date: "2025-11-14",
    time: "15:34:15",
    verified: false,
    images: [],
    description: "The colour online looked much richer than what arrived. It's quite washed out in person. The stitching around the neckline is also a bit loose. Might just be a bad batch but I'm not impressed.",
    helpful: []
  },
  {
    id: 34,
    productId: 9,
    userName: "Deirdre Connolly",
    userHandle: "@deirdreconnolly",
    rating: 2,
    summary: "Not what I expected",
    date: "2023-09-20",
    time: "21:29:44",
    verified: false,
    images: [],
    description: "The colour online looked much richer than what arrived. It's quite washed out in person. The stitching around the neckline is also a bit loose. Might just be a bad batch but I'm not impressed.",
    helpful: ["user1_id", "user2_id"]
  },
  {
    id: 35,
    productId: 9,
    userName: "Killian Hughes",
    userHandle: "@killianhughes",
    rating: 4,
    summary: "Pleased with this purchase",
    date: "2026-02-09",
    time: "13:13:43",
    verified: false,
    images: [],
    description: "Bought this on a whim and I'm glad I did. It's well made and the fit is flattering without being too tight. The colour is exactly as shown in the photos. A solid wardrobe staple.",
    helpful: []
  },
  {
    id: 36,
    productId: 11,
    userName: "Emer Doherty",
    userHandle: "@emerdoherty",
    rating: 4,
    summary: "Pleased with this purchase",
    date: "2024-10-29",
    time: "12:12:29",
    verified: false,
    images: [],
    description: "Bought this on a whim and I'm glad I did. It's well made and the fit is flattering without being too tight. The colour is exactly as shown in the photos. A solid wardrobe staple.",
    helpful: ["user1_id", "user2_id", "user3_id", "user4_id", "user5_id", "user6_id"]
  },
  {
    id: 37,
    productId: 11,
    userName: "Phelim Barry",
    userHandle: "@phelimbarry",
    rating: 4,
    summary: "Great for everyday wear",
    date: "2025-10-23",
    time: "08:00:00",
    verified: true,
    images: [],
    description: "Comfortable, stylish and easy to throw on. Works well with jeans or dressed up with a skirt. The material is decent quality and holds its shape well. Would be 5 stars if there were more colour options.",
    helpful: []
  },
  {
    id: 38,
    productId: 11,
    userName: "Ailbhe Whelan",
    userHandle: "@ailbhewhelan",
    rating: 5,
    summary: "My new favourite top",
    date: "2024-05-15",
    time: "20:36:24",
    verified: true,
    images: [],
    description: "I wear this constantly. It goes with everything in my wardrobe and is comfortable enough for all day wear. The fabric has a lovely drape and doesn't cling in unflattering places. Highly recommend.",
    helpful: ["user1_id", "user2_id", "user3_id", "user4_id", "user5_id"]
  },
  {
    id: 39,
    productId: 11,
    userName: "Tiernan Kenny",
    userHandle: "@tiernankenny",
    rating: 5,
    summary: "Absolutely love this!",
    date: "2024-03-18",
    time: "15:09:32",
    verified: false,
    images: [],
    description: "The quality is incredible for the price. It's so soft against my skin and the colour hasn't faded after multiple washes. I've already ordered a second one in a different colour. True to size and flattering on.",
    helpful: ["user1_id", "user2_id", "user3_id", "user4_id", "user5_id", "user6_id", "user7_id"]
  },
  {
    id: 40,
    productId: 11,
    userName: "Bronagh Casey",
    userHandle: "@bronaghcasey",
    rating: 5,
    summary: "Absolutely love this!",
    date: "2025-01-31",
    time: "14:10:53",
    verified: true,
    images: [],
    description: "The quality is incredible for the price. It's so soft against my skin and the colour hasn't faded after multiple washes. I've already ordered a second one in a different colour. True to size and flattering on.",
    helpful: ["user1_id", "user2_id", "user3_id", "user4_id", "user5_id", "user6_id"]
  },
  {
    id: 41,
    productId: 12,
    userName: "Fintan Sheehan",
    userHandle: "@fintansheehan",
    rating: 4,
    summary: "Pleased with this purchase",
    date: "2025-12-14",
    time: "18:45:07",
    verified: true,
    images: [],
    description: "Bought this on a whim and I'm glad I did. It's well made and the fit is flattering without being too tight. The colour is exactly as shown in the photos. A solid wardrobe staple.",
    helpful: ["user1_id", "user2_id", "user3_id", "user4_id", "user5_id"]
  },
  {
    id: 42,
    productId: 12,
    userName: "Muireann Long",
    userHandle: "@muireannlong",
    rating: 2,
    summary: "Disappointed with the sizing",
    date: "2024-03-29",
    time: "08:26:25",
    verified: false,
    images: [],
    description: "I usually wear a medium and ordered my usual size but this runs really small. Had to return and size up. The fabric also isn't as thick as the photos suggest. Not great for the price.",
    helpful: ["user1_id", "user2_id", "user3_id", "user4_id"]
  },
  {
    id: 43,
    productId: 12,
    userName: "Daire Griffin",
    userHandle: "@dairegriffin",
    rating: 4,
    summary: "Really nice, one small issue",
    date: "2025-03-01",
    time: "10:22:00",
    verified: true,
    images: [],
    description: "Overall a great purchase. The fabric is lovely and soft, sits nicely on the body. Only giving 4 stars because the sleeves are slightly shorter than I expected. I'm 5'7 and they sit just above my wrist. Otherwise perfect.",
    helpful: ["user1_id", "user2_id", "user3_id", "user4_id", "user5_id"]
  },
  {
    id: 44,
    productId: 12,
    userName: "Sorcha Flynn",
    userHandle: "@sorchaflynn",
    rating: 5,
    summary: "My new favourite top",
    date: "2024-01-14",
    time: "10:46:24",
    verified: false,
    images: [],
    description: "I wear this constantly. It goes with everything in my wardrobe and is comfortable enough for all day wear. The fabric has a lovely drape and doesn't cling in unflattering places. Highly recommend.",
    helpful: ["user1_id", "user2_id"]
  },
  {
    id: 45,
    productId: 13,
    userName: "Lorcan Duffy",
    userHandle: "@lorcanduffy",
    rating: 2,
    summary: "Runs large",
    date: "2023-09-01",
    time: "09:15:26",
    verified: true,
    images: [],
    description: "Ordered my usual size and it's way too big. The shoulders are drooping and the body is very boxy. The material also feels cheaper in person than it looks online. Returning this.",
    helpful: []
  },
  {
    id: 46,
    productId: 13,
    userName: "Rachel Moore",
    userHandle: "@rachelmoore",
    rating: 4,
    summary: "Great casual shirt",
    date: "2025-08-11",
    time: "14:07:27",
    verified: true,
    images: [],
    description: "Looks sharp and feels comfortable. I've been wearing it with chinos and it looks class. The buttons feel sturdy and the stitching is clean. Only minor gripe is the collar could be a bit stiffer.",
    helpful: []
  },
  {
    id: 47,
    productId: 14,
    userName: "Tom Henderson",
    userHandle: "@tomhenderson",
    rating: 3,
    summary: "Fine for the price",
    date: "2024-06-20",
    time: "17:58:09",
    verified: true,
    images: [],
    description: "Got what I paid for I suppose. The fabric is a bit thin and wrinkles easily. Looks decent enough when ironed. Wouldn't pay full price but okay on sale.",
    helpful: []
  },
  {
    id: 48,
    productId: 14,
    userName: "Sarah Donahue",
    userHandle: "@sarahdonahue",
    rating: 5,
    summary: "Excellent quality and fit",
    date: "2024-02-08",
    time: "15:58:18",
    verified: false,
    images: [],
    description: "Really impressed with this. The material is thick but not heavy, and it looks much more expensive than it is. True to size, I got a large and it fits perfectly on my 6'1 frame.",
    helpful: ["user1_id", "user2_id", "user3_id"]
  },
  {
    id: 49,
    productId: 14,
    userName: "Mark O'Connell",
    userHandle: "@markoconnell",
    rating: 4,
    summary: "Really like this one",
    date: "2025-11-23",
    time: "20:48:04",
    verified: false,
    images: [],
    description: "Got loads of compliments wearing this out. The colour is spot on and the material feels quality. Slightly long in the body for me but I just tuck it in. Overall very pleased.",
    helpful: []
  },
  {
    id: 50,
    productId: 14,
    userName: "Hannah Taylor",
    userHandle: "@hannahtaylor",
    rating: 2,
    summary: "Runs large",
    date: "2023-06-13",
    time: "13:24:42",
    verified: false,
    images: [],
    description: "Ordered my usual size and it's way too big. The shoulders are drooping and the body is very boxy. The material also feels cheaper in person than it looks online. Returning this.",
    helpful: ["user1_id", "user2_id", "user3_id", "user4_id"]
  },
  {
    id: 51,
    productId: 14,
    userName: "Ben Collins",
    userHandle: "@bencollins",
    rating: 5,
    summary: "Best shirt I own",
    date: "2025-06-02",
    time: "18:47:30",
    verified: true,
    images: [],
    description: "The fit is spot on — not too tight, not too loose. The fabric feels premium and breathes well. I've worn it to the office and on weekends. Genuinely one of the best purchases I've made in a while.",
    helpful: ["user1_id", "user2_id", "user3_id", "user4_id"]
  },
  {
    id: 52,
    productId: 15,
    userName: "Lucy Bennett",
    userHandle: "@lucybennett",
    rating: 4,
    summary: "Good value for money",
    date: "2024-03-26",
    time: "13:36:35",
    verified: false,
    images: [],
    description: "Solid shirt for the price. The fabric has a nice texture and the fit is modern without being too slim. Washes well and doesn't shrink. Would happily buy again in a different colour.",
    helpful: ["user1_id", "user2_id"]
  },
  {
    id: 53,
    productId: 15,
    userName: "James Ward",
    userHandle: "@jamesward",
    rating: 4,
    summary: "Really like this one",
    date: "2024-11-13",
    time: "16:18:29",
    verified: false,
    images: [],
    description: "Got loads of compliments wearing this out. The colour is spot on and the material feels quality. Slightly long in the body for me but I just tuck it in. Overall very pleased.",
    helpful: ["user1_id"]
  },
  {
    id: 54,
    productId: 15,
    userName: "Emily Clarke",
    userHandle: "@emilyclarke",
    rating: 5,
    summary: "Best shirt I own",
    date: "2024-04-09",
    time: "10:10:13",
    verified: false,
    images: [],
    description: "The fit is spot on — not too tight, not too loose. The fabric feels premium and breathes well. I've worn it to the office and on weekends. Genuinely one of the best purchases I've made in a while.",
    helpful: ["user1_id", "user2_id", "user3_id", "user4_id", "user5_id", "user6_id"]
  },
  {
    id: 55,
    productId: 15,
    userName: "Sean Murphy",
    userHandle: "@seanmurphy",
    rating: 5,
    summary: "Best shirt I own",
    date: "2024-06-01",
    time: "20:31:53",
    verified: false,
    images: [],
    description: "The fit is spot on — not too tight, not too loose. The fabric feels premium and breathes well. I've worn it to the office and on weekends. Genuinely one of the best purchases I've made in a while.",
    helpful: ["user1_id", "user2_id", "user3_id", "user4_id", "user5_id", "user6_id"]
  },
  {
    id: 56,
    productId: 15,
    userName: "Aoife Byrne",
    userHandle: "@aoifebyrne",
    rating: 5,
    summary: "Best shirt I own",
    date: "2025-05-11",
    time: "09:05:24",
    verified: false,
    images: [],
    description: "The fit is spot on — not too tight, not too loose. The fabric feels premium and breathes well. I've worn it to the office and on weekends. Genuinely one of the best purchases I've made in a while.",
    helpful: []
  },
  {
    id: 57,
    productId: 15,
    userName: "Ciaran Kelly",
    userHandle: "@ciarankelly",
    rating: 4,
    summary: "Good value for money",
    date: "2026-01-20",
    time: "16:02:52",
    verified: false,
    images: [],
    description: "Solid shirt for the price. The fabric has a nice texture and the fit is modern without being too slim. Washes well and doesn't shrink. Would happily buy again in a different colour.",
    helpful: ["user1_id", "user2_id", "user3_id", "user4_id", "user5_id", "user6_id", "user7_id"]
  },
  {
    id: 58,
    productId: 16,
    userName: "Niamh Walsh",
    userHandle: "@niamhwalsh",
    rating: 4,
    summary: "Good value for money",
    date: "2024-11-28",
    time: "09:32:57",
    verified: true,
    images: [],
    description: "Solid shirt for the price. The fabric has a nice texture and the fit is modern without being too slim. Washes well and doesn't shrink. Would happily buy again in a different colour.",
    helpful: ["user1_id"]
  },
  {
    id: 59,
    productId: 16,
    userName: "Declan Ryan",
    userHandle: "@declanryan",
    rating: 4,
    summary: "Great casual shirt",
    date: "2025-07-10",
    time: "14:18:38",
    verified: false,
    images: [],
    description: "Looks sharp and feels comfortable. I've been wearing it with chinos and it looks class. The buttons feel sturdy and the stitching is clean. Only minor gripe is the collar could be a bit stiffer.",
    helpful: ["user1_id"]
  },
  {
    id: 60,
    productId: 16,
    userName: "Siobhan O'Brien",
    userHandle: "@siobhanobrien",
    rating: 4,
    summary: "Really like this one",
    date: "2024-05-13",
    time: "20:14:07",
    verified: true,
    images: [],
    description: "Got loads of compliments wearing this out. The colour is spot on and the material feels quality. Slightly long in the body for me but I just tuck it in. Overall very pleased.",
    helpful: ["user1_id", "user2_id"]
  },
  {
    id: 61,
    productId: 16,
    userName: "Padraig Doyle",
    userHandle: "@padraigdoyle",
    rating: 2,
    summary: "Not impressed",
    date: "2023-11-08",
    time: "14:18:19",
    verified: false,
    images: [],
    description: "The colour faded noticeably after just one wash which is really poor. The fabric has an odd chemical smell when new. Design is nice but the quality just isn't there.",
    helpful: []
  },
  {
    id: 62,
    productId: 16,
    userName: "Roisin Gallagher",
    userHandle: "@roisingallagher",
    rating: 4,
    summary: "Really like this one",
    date: "2025-09-10",
    time: "20:09:24",
    verified: false,
    images: [],
    description: "Got loads of compliments wearing this out. The colour is spot on and the material feels quality. Slightly long in the body for me but I just tuck it in. Overall very pleased.",
    helpful: []
  },
  {
    id: 63,
    productId: 17,
    userName: "Conor Fitzgerald",
    userHandle: "@conorfitzgerald",
    rating: 1,
    summary: "Wouldn't recommend",
    date: "2024-06-17",
    time: "13:26:25",
    verified: true,
    images: [],
    description: "Terrible quality for the price. A button fell off on the first wear and the stitching is wonky in places. The material is stiff and uncomfortable. Complete waste of money.",
    helpful: []
  },
  {
    id: 64,
    productId: 17,
    userName: "Saoirse Brennan",
    userHandle: "@saoirsebrennan",
    rating: 5,
    summary: "Excellent quality and fit",
    date: "2024-04-23",
    time: "08:20:51",
    verified: false,
    images: [],
    description: "Really impressed with this. The material is thick but not heavy, and it looks much more expensive than it is. True to size, I got a large and it fits perfectly on my 6'1 frame.",
    helpful: ["user1_id", "user2_id"]
  },
  {
    id: 65,
    productId: 17,
    userName: "Eoin McCarthy",
    userHandle: "@eoinmccarthy",
    rating: 5,
    summary: "Excellent quality and fit",
    date: "2025-05-17",
    time: "20:09:33",
    verified: false,
    images: [],
    description: "Really impressed with this. The material is thick but not heavy, and it looks much more expensive than it is. True to size, I got a large and it fits perfectly on my 6'1 frame.",
    helpful: ["user1_id", "user2_id", "user3_id", "user4_id", "user5_id"]
  },
  {
    id: 66,
    productId: 17,
    userName: "Caoimhe Nolan",
    userHandle: "@caoimhenolan",
    rating: 5,
    summary: "Best shirt I own",
    date: "2024-03-12",
    time: "17:34:41",
    verified: true,
    images: [],
    description: "The fit is spot on — not too tight, not too loose. The fabric feels premium and breathes well. I've worn it to the office and on weekends. Genuinely one of the best purchases I've made in a while.",
    helpful: ["user1_id", "user2_id", "user3_id", "user4_id", "user5_id", "user6_id"]
  },
  {
    id: 67,
    productId: 17,
    userName: "Oisin Kavanagh",
    userHandle: "@oisinkavanagh",
    rating: 1,
    summary: "Wouldn't recommend",
    date: "2025-01-05",
    time: "11:36:37",
    verified: false,
    images: [],
    description: "Terrible quality for the price. A button fell off on the first wear and the stitching is wonky in places. The material is stiff and uncomfortable. Complete waste of money.",
    helpful: ["user1_id", "user2_id"]
  },
  {
    id: 68,
    productId: 17,
    userName: "Maeve Dunne",
    userHandle: "@maevedunne",
    rating: 3,
    summary: "It's alright",
    date: "2025-03-01",
    time: "21:54:32",
    verified: false,
    images: [],
    description: "Nothing wrong with it but nothing amazing either. The fit is a bit loose around the arms for my liking. Material is fine, not the softest but it does the job. Okay for casual wear.",
    helpful: ["user1_id", "user2_id", "user3_id", "user4_id", "user5_id"]
  },
  {
    id: 69,
    productId: 17,
    userName: "Cillian Power",
    userHandle: "@cillianpower",
    rating: 2,
    summary: "Runs large",
    date: "2024-04-17",
    time: "08:45:57",
    verified: false,
    images: [],
    description: "Ordered my usual size and it's way too big. The shoulders are drooping and the body is very boxy. The material also feels cheaper in person than it looks online. Returning this.",
    helpful: ["user1_id", "user2_id", "user3_id", "user4_id", "user5_id"]
  },
  {
    id: 70,
    productId: 17,
    userName: "Fiona Healy",
    userHandle: "@fionahealy",
    rating: 1,
    summary: "Wouldn't recommend",
    date: "2025-02-23",
    time: "21:41:35",
    verified: false,
    images: [],
    description: "Terrible quality for the price. A button fell off on the first wear and the stitching is wonky in places. The material is stiff and uncomfortable. Complete waste of money.",
    helpful: []
  },
  {
    id: 71,
    productId: 18,
    userName: "Liam Daly",
    userHandle: "@liamdaly",
    rating: 3,
    summary: "It's alright",
    date: "2024-04-21",
    time: "12:30:57",
    verified: false,
    images: [],
    description: "Nothing wrong with it but nothing amazing either. The fit is a bit loose around the arms for my liking. Material is fine, not the softest but it does the job. Okay for casual wear.",
    helpful: ["user1_id", "user2_id", "user3_id"]
  },
  {
    id: 72,
    productId: 18,
    userName: "Orla Quinn",
    userHandle: "@orlaquinn",
    rating: 5,
    summary: "Best shirt I own",
    date: "2024-12-28",
    time: "21:55:36",
    verified: false,
    images: [],
    description: "The fit is spot on — not too tight, not too loose. The fabric feels premium and breathes well. I've worn it to the office and on weekends. Genuinely one of the best purchases I've made in a while.",
    helpful: []
  },
  {
    id: 73,
    productId: 18,
    userName: "Darragh Keane",
    userHandle: "@darraghkeane",
    rating: 4,
    summary: "Good value for money",
    date: "2025-10-18",
    time: "18:29:26",
    verified: true,
    images: [],
    description: "Solid shirt for the price. The fabric has a nice texture and the fit is modern without being too slim. Washes well and doesn't shrink. Would happily buy again in a different colour.",
    helpful: []
  },
  {
    id: 74,
    productId: 18,
    userName: "Aine Reilly",
    userHandle: "@ainereilly",
    rating: 3,
    summary: "It's alright",
    date: "2025-02-27",
    time: "18:42:39",
    verified: false,
    images: [],
    description: "Nothing wrong with it but nothing amazing either. The fit is a bit loose around the arms for my liking. Material is fine, not the softest but it does the job. Okay for casual wear.",
    helpful: []
  },
  {
    id: 75,
    productId: 18,
    userName: "Cathal Moran",
    userHandle: "@cathalmoran",
    rating: 5,
    summary: "Excellent quality and fit",
    date: "2025-05-03",
    time: "12:19:22",
    verified: false,
    images: [],
    description: "Really impressed with this. The material is thick but not heavy, and it looks much more expensive than it is. True to size, I got a large and it fits perfectly on my 6'1 frame.",
    helpful: ["user1_id", "user2_id", "user3_id", "user4_id", "user5_id"]
  },
  {
    id: 76,
    productId: 18,
    userName: "Grainne Farrell",
    userHandle: "@grainnefarrell",
    rating: 3,
    summary: "Fine for the price",
    date: "2025-09-24",
    time: "17:23:05",
    verified: false,
    images: [],
    description: "Got what I paid for I suppose. The fabric is a bit thin and wrinkles easily. Looks decent enough when ironed. Wouldn't pay full price but okay on sale.",
    helpful: ["user1_id", "user2_id", "user3_id", "user4_id", "user5_id"]
  },
  {
    id: 77,
    productId: 21,
    userName: "Tadhg Lynch",
    userHandle: "@tadhglynch",
    rating: 3,
    summary: "Decent but could be better",
    date: "2024-11-20",
    time: "11:14:13",
    verified: false,
    images: [],
    description: "The fit is okay but the waist runs a bit tight. Had to go up a size. The fabric is fine but nothing special. They serve their purpose for work but I've had better.",
    helpful: ["user1_id", "user2_id", "user3_id"]
  },
  {
    id: 78,
    productId: 21,
    userName: "Clodagh Murray",
    userHandle: "@clodaghmurray",
    rating: 1,
    summary: "Cheap feeling",
    date: "2024-09-02",
    time: "09:02:09",
    verified: false,
    images: [],
    description: "The material feels plasticky and doesn't breathe at all. By the end of the day I was really uncomfortable. The fit is also odd — tight on the thighs but baggy at the ankles.",
    helpful: ["user1_id", "user2_id", "user3_id", "user4_id", "user5_id", "user6_id", "user7_id"]
  },
  {
    id: 79,
    productId: 21,
    userName: "Ronan Smyth",
    userHandle: "@ronansmyth",
    rating: 2,
    summary: "Cheap feeling",
    date: "2023-09-21",
    time: "11:27:02",
    verified: false,
    images: [],
    description: "The material feels plasticky and doesn't breathe at all. By the end of the day I was really uncomfortable. The fit is also odd — tight on the thighs but baggy at the ankles.",
    helpful: []
  },
  {
    id: 80,
    productId: 21,
    userName: "Sinead Burke",
    userHandle: "@sineadburke",
    rating: 4,
    summary: "Good everyday trousers",
    date: "2024-04-12",
    time: "09:53:14",
    verified: false,
    images: [],
    description: "Solid purchase. They fit well and the quality is decent. The colour is true to the photos. Only wish the pockets were a bit deeper but that's a minor complaint.",
    helpful: []
  },
  {
    id: 81,
    productId: 22,
    userName: "Fergal O'Sullivan",
    userHandle: "@fergalosullivan",
    rating: 5,
    summary: "Excellent quality and fit",
    date: "2026-02-16",
    time: "16:34:29",
    verified: false,
    images: [],
    description: "Really impressed with this. The material is thick but not heavy, and it looks much more expensive than it is. True to size, I got a large and it fits perfectly on my 6'1 frame.",
    helpful: ["user1_id", "user2_id", "user3_id", "user4_id"]
  },
  {
    id: 82,
    productId: 22,
    userName: "Deirdre Connolly",
    userHandle: "@deirdreconnolly",
    rating: 5,
    summary: "Best shirt I own",
    date: "2024-03-13",
    time: "16:45:30",
    verified: false,
    images: [],
    description: "The fit is spot on — not too tight, not too loose. The fabric feels premium and breathes well. I've worn it to the office and on weekends. Genuinely one of the best purchases I've made in a while.",
    helpful: []
  },
  {
    id: 83,
    productId: 22,
    userName: "Killian Hughes",
    userHandle: "@killianhughes",
    rating: 4,
    summary: "Good value for money",
    date: "2025-02-13",
    time: "18:06:23",
    verified: true,
    images: [],
    description: "Solid shirt for the price. The fabric has a nice texture and the fit is modern without being too slim. Washes well and doesn't shrink. Would happily buy again in a different colour.",
    helpful: []
  },
  {
    id: 84,
    productId: 22,
    userName: "Emer Doherty",
    userHandle: "@emerdoherty",
    rating: 4,
    summary: "Great casual shirt",
    date: "2024-02-10",
    time: "10:48:40",
    verified: true,
    images: [],
    description: "Looks sharp and feels comfortable. I've been wearing it with chinos and it looks class. The buttons feel sturdy and the stitching is clean. Only minor gripe is the collar could be a bit stiffer.",
    helpful: ["user1_id", "user2_id", "user3_id", "user4_id", "user5_id", "user6_id", "user7_id"]
  },
  {
    id: 85,
    productId: 23,
    userName: "Phelim Barry",
    userHandle: "@phelimbarry",
    rating: 4,
    summary: "Good value for money",
    date: "2025-03-05",
    time: "17:04:09",
    verified: true,
    images: [],
    description: "Solid shirt for the price. The fabric has a nice texture and the fit is modern without being too slim. Washes well and doesn't shrink. Would happily buy again in a different colour.",
    helpful: ["user1_id", "user2_id", "user3_id", "user4_id"]
  },
  {
    id: 86,
    productId: 23,
    userName: "Ailbhe Whelan",
    userHandle: "@ailbhewhelan",
    rating: 4,
    summary: "Really like this one",
    date: "2024-06-04",
    time: "20:27:21",
    verified: false,
    images: [],
    description: "Got loads of compliments wearing this out. The colour is spot on and the material feels quality. Slightly long in the body for me but I just tuck it in. Overall very pleased.",
    helpful: ["user1_id", "user2_id", "user3_id", "user4_id", "user5_id", "user6_id"]
  },
  {
    id: 87,
    productId: 23,
    userName: "Tiernan Kenny",
    userHandle: "@tiernankenny",
    rating: 3,
    summary: "It's alright",
    date: "2025-06-24",
    time: "15:11:15",
    verified: true,
    images: [],
    description: "Nothing wrong with it but nothing amazing either. The fit is a bit loose around the arms for my liking. Material is fine, not the softest but it does the job. Okay for casual wear.",
    helpful: []
  },
  {
    id: 88,
    productId: 23,
    userName: "Bronagh Casey",
    userHandle: "@bronaghcasey",
    rating: 5,
    summary: "Excellent quality and fit",
    date: "2024-05-12",
    time: "20:51:19",
    verified: false,
    images: [],
    description: "Really impressed with this. The material is thick but not heavy, and it looks much more expensive than it is. True to size, I got a large and it fits perfectly on my 6'1 frame.",
    helpful: []
  },
  {
    id: 89,
    productId: 23,
    userName: "Fintan Sheehan",
    userHandle: "@fintansheehan",
    rating: 3,
    summary: "Fine for the price",
    date: "2025-03-17",
    time: "15:41:09",
    verified: true,
    images: [],
    description: "Got what I paid for I suppose. The fabric is a bit thin and wrinkles easily. Looks decent enough when ironed. Wouldn't pay full price but okay on sale.",
    helpful: ["user1_id", "user2_id"]
  },
  {
    id: 90,
    productId: 23,
    userName: "Muireann Long",
    userHandle: "@muireannlong",
    rating: 1,
    summary: "Wouldn't recommend",
    date: "2025-10-26",
    time: "21:53:10",
    verified: true,
    images: [],
    description: "Terrible quality for the price. A button fell off on the first wear and the stitching is wonky in places. The material is stiff and uncomfortable. Complete waste of money.",
    helpful: ["user1_id", "user2_id", "user3_id", "user4_id", "user5_id", "user6_id", "user7_id"]
  },
  {
    id: 91,
    productId: 24,
    userName: "Daire Griffin",
    userHandle: "@dairegriffin",
    rating: 4,
    summary: "Smart and comfortable",
    date: "2025-08-24",
    time: "09:44:18",
    verified: true,
    images: [],
    description: "Nice trousers for the price. The cut is clean and they sit well on the waist. Good for work or a night out. The material is comfortable and doesn't crease too badly.",
    helpful: ["user1_id", "user2_id", "user3_id", "user4_id", "user5_id", "user6_id"]
  },
  {
    id: 92,
    productId: 24,
    userName: "Sorcha Flynn",
    userHandle: "@sorchaflynn",
    rating: 5,
    summary: "Perfect fit, great quality",
    date: "2024-12-15",
    time: "09:43:38",
    verified: false,
    images: [],
    description: "These are my go-to trousers now. The fit is exactly right — slim without being skinny. The fabric has just enough stretch for comfort and they look sharp for the office. Very pleased.",
    helpful: ["user1_id", "user2_id", "user3_id", "user4_id", "user5_id", "user6_id"]
  },
  {
    id: 93,
    productId: 24,
    userName: "Lorcan Duffy",
    userHandle: "@lorcanduffy",
    rating: 3,
    summary: "Decent but could be better",
    date: "2025-06-10",
    time: "13:09:04",
    verified: false,
    images: [],
    description: "The fit is okay but the waist runs a bit tight. Had to go up a size. The fabric is fine but nothing special. They serve their purpose for work but I've had better.",
    helpful: ["user1_id", "user2_id", "user3_id", "user4_id"]
  },
  {
    id: 94,
    productId: 24,
    userName: "Rachel Moore",
    userHandle: "@rachelmoore",
    rating: 3,
    summary: "Decent but could be better",
    date: "2025-03-26",
    time: "18:40:05",
    verified: false,
    images: [],
    description: "The fit is okay but the waist runs a bit tight. Had to go up a size. The fabric is fine but nothing special. They serve their purpose for work but I've had better.",
    helpful: ["user1_id", "user2_id", "user3_id"]
  },
  {
    id: 95,
    productId: 24,
    userName: "Tom Henderson",
    userHandle: "@tomhenderson",
    rating: 5,
    summary: "Perfect fit, great quality",
    date: "2023-07-15",
    time: "15:20:18",
    verified: true,
    images: [],
    description: "These are my go-to trousers now. The fit is exactly right — slim without being skinny. The fabric has just enough stretch for comfort and they look sharp for the office. Very pleased.",
    helpful: ["user1_id", "user2_id", "user3_id", "user4_id", "user5_id", "user6_id"]
  },
  {
    id: 96,
    productId: 24,
    userName: "Sarah Donahue",
    userHandle: "@sarahdonahue",
    rating: 5,
    summary: "Perfect fit, great quality",
    date: "2024-06-07",
    time: "15:16:58",
    verified: false,
    images: [],
    description: "These are my go-to trousers now. The fit is exactly right — slim without being skinny. The fabric has just enough stretch for comfort and they look sharp for the office. Very pleased.",
    helpful: []
  },
  {
    id: 97,
    productId: 25,
    userName: "Mark O'Connell",
    userHandle: "@markoconnell",
    rating: 3,
    summary: "It's okay",
    date: "2025-04-01",
    time: "16:58:39",
    verified: true,
    images: [],
    description: "Not bad but the fabric is thinner than expected. It's fine for summer or layering but won't keep him warm on its own. The fit is good though and he seems comfortable in it.",
    helpful: ["user1_id", "user2_id"]
  },
  {
    id: 98,
    productId: 25,
    userName: "Hannah Taylor",
    userHandle: "@hannahtaylor",
    rating: 5,
    summary: "Son loves it!",
    date: "2025-01-11",
    time: "20:09:53",
    verified: false,
    images: [],
    description: "Bought this for my 8 year old and he hasn't taken it off since. The fabric is super soft and has held up brilliantly in the wash. The colours haven't faded at all. Great quality for kids' clothing.",
    helpful: []
  },
  {
    id: 99,
    productId: 25,
    userName: "Ben Collins",
    userHandle: "@bencollins",
    rating: 2,
    summary: "Shrunk in the wash",
    date: "2025-11-25",
    time: "10:50:55",
    verified: false,
    images: [],
    description: "After one wash on 30 degrees it shrank noticeably. Had to size up which is annoying. The material is also pilling already. Disappointing for a brand like this.",
    helpful: []
  },
  {
    id: 100,
    productId: 25,
    userName: "Lucy Bennett",
    userHandle: "@lucybennett",
    rating: 3,
    summary: "It's okay",
    date: "2025-06-19",
    time: "20:00:21",
    verified: true,
    images: [],
    description: "Not bad but the fabric is thinner than expected. It's fine for summer or layering but won't keep him warm on its own. The fit is good though and he seems comfortable in it.",
    helpful: []
  },
  {
    id: 101,
    productId: 26,
    userName: "James Ward",
    userHandle: "@jamesward",
    rating: 4,
    summary: "Great value",
    date: "2023-09-01",
    time: "08:19:35",
    verified: true,
    images: [],
    description: "Impressed with this for the price. It washes well and dries quickly. The fit is good and my boy likes wearing it. Will pick up a couple more for the back-to-school wardrobe.",
    helpful: ["user1_id", "user2_id"]
  },
  {
    id: 102,
    productId: 26,
    userName: "Emily Clarke",
    userHandle: "@emilyclarke",
    rating: 5,
    summary: "Brilliant for school",
    date: "2026-01-26",
    time: "17:39:12",
    verified: true,
    images: [],
    description: "Perfect for layering under his school jumper. The fit is great and there's room to grow without looking oversized. Really well made — I'll definitely be buying more from this range.",
    helpful: ["user1_id", "user2_id", "user3_id"]
  },
  {
    id: 103,
    productId: 27,
    userName: "Sean Murphy",
    userHandle: "@seanmurphy",
    rating: 5,
    summary: "Brilliant for school",
    date: "2025-08-17",
    time: "13:11:00",
    verified: true,
    images: [],
    description: "Perfect for layering under his school jumper. The fit is great and there's room to grow without looking oversized. Really well made — I'll definitely be buying more from this range.",
    helpful: ["user1_id", "user2_id"]
  },
  {
    id: 104,
    productId: 27,
    userName: "Aoife Byrne",
    userHandle: "@aoifebyrne",
    rating: 4,
    summary: "Great value",
    date: "2024-12-11",
    time: "18:52:09",
    verified: false,
    images: [],
    description: "Impressed with this for the price. It washes well and dries quickly. The fit is good and my boy likes wearing it. Will pick up a couple more for the back-to-school wardrobe.",
    helpful: []
  },
  {
    id: 105,
    productId: 27,
    userName: "Ciaran Kelly",
    userHandle: "@ciarankelly",
    rating: 4,
    summary: "Great value",
    date: "2025-07-16",
    time: "09:16:02",
    verified: false,
    images: [],
    description: "Impressed with this for the price. It washes well and dries quickly. The fit is good and my boy likes wearing it. Will pick up a couple more for the back-to-school wardrobe.",
    helpful: []
  },
  {
    id: 106,
    productId: 27,
    userName: "Niamh Walsh",
    userHandle: "@niamhwalsh",
    rating: 5,
    summary: "Son loves it!",
    date: "2024-03-03",
    time: "08:22:57",
    verified: true,
    images: [],
    description: "Bought this for my 8 year old and he hasn't taken it off since. The fabric is super soft and has held up brilliantly in the wash. The colours haven't faded at all. Great quality for kids' clothing.",
    helpful: ["user1_id", "user2_id", "user3_id"]
  },
  {
    id: 107,
    productId: 29,
    userName: "Declan Ryan",
    userHandle: "@declanryan",
    rating: 5,
    summary: "Son loves it!",
    date: "2024-06-04",
    time: "21:19:34",
    verified: false,
    images: [],
    description: "Bought this for my 8 year old and he hasn't taken it off since. The fabric is super soft and has held up brilliantly in the wash. The colours haven't faded at all. Great quality for kids' clothing.",
    helpful: ["user1_id", "user2_id", "user3_id", "user4_id"]
  },
  {
    id: 108,
    productId: 29,
    userName: "Siobhan O'Brien",
    userHandle: "@siobhanobrien",
    rating: 3,
    summary: "It's okay",
    date: "2024-07-18",
    time: "15:12:09",
    verified: true,
    images: [],
    description: "Not bad but the fabric is thinner than expected. It's fine for summer or layering but won't keep him warm on its own. The fit is good though and he seems comfortable in it.",
    helpful: ["user1_id", "user2_id", "user3_id", "user4_id", "user5_id"]
  },
  {
    id: 109,
    productId: 29,
    userName: "Padraig Doyle",
    userHandle: "@padraigdoyle",
    rating: 4,
    summary: "Nice quality kids' top",
    date: "2025-10-18",
    time: "12:43:25",
    verified: true,
    images: [],
    description: "Good quality fabric and well stitched. My son finds it comfortable which is the main thing. The sizing is accurate. Would have given 5 stars but the design is a bit plain for his taste.",
    helpful: ["user1_id", "user2_id", "user3_id", "user4_id", "user5_id", "user6_id"]
  },
  {
    id: 110,
    productId: 29,
    userName: "Roisin Gallagher",
    userHandle: "@roisingallagher",
    rating: 2,
    summary: "Shrunk in the wash",
    date: "2024-12-06",
    time: "18:42:08",
    verified: true,
    images: [],
    description: "After one wash on 30 degrees it shrank noticeably. Had to size up which is annoying. The material is also pilling already. Disappointing for a brand like this.",
    helpful: []
  },
  {
    id: 111,
    productId: 29,
    userName: "Conor Fitzgerald",
    userHandle: "@conorfitzgerald",
    rating: 3,
    summary: "It's okay",
    date: "2024-07-26",
    time: "19:11:20",
    verified: true,
    images: [],
    description: "Not bad but the fabric is thinner than expected. It's fine for summer or layering but won't keep him warm on its own. The fit is good though and he seems comfortable in it.",
    helpful: ["user1_id", "user2_id"]
  },
  {
    id: 112,
    productId: 29,
    userName: "Saoirse Brennan",
    userHandle: "@saoirsebrennan",
    rating: 1,
    summary: "Shrunk in the wash",
    date: "2025-09-10",
    time: "10:29:14",
    verified: true,
    images: [],
    description: "After one wash on 30 degrees it shrank noticeably. Had to size up which is annoying. The material is also pilling already. Disappointing for a brand like this.",
    helpful: ["user1_id", "user2_id", "user3_id"]
  },
  {
    id: 113,
    productId: 30,
    userName: "Eoin McCarthy",
    userHandle: "@eoinmccarthy",
    rating: 4,
    summary: "Nice quality kids' top",
    date: "2023-12-25",
    time: "09:04:57",
    verified: true,
    images: [],
    description: "Good quality fabric and well stitched. My son finds it comfortable which is the main thing. The sizing is accurate. Would have given 5 stars but the design is a bit plain for his taste.",
    helpful: []
  },
  {
    id: 114,
    productId: 30,
    userName: "Caoimhe Nolan",
    userHandle: "@caoimhenolan",
    rating: 5,
    summary: "Son loves it!",
    date: "2025-01-08",
    time: "12:12:08",
    verified: true,
    images: [],
    description: "Bought this for my 8 year old and he hasn't taken it off since. The fabric is super soft and has held up brilliantly in the wash. The colours haven't faded at all. Great quality for kids' clothing.",
    helpful: ["user1_id", "user2_id", "user3_id", "user4_id", "user5_id"]
  },
  {
    id: 115,
    productId: 30,
    userName: "Oisin Kavanagh",
    userHandle: "@oisinkavanagh",
    rating: 3,
    summary: "It's okay",
    date: "2023-06-25",
    time: "14:47:20",
    verified: true,
    images: [],
    description: "Not bad but the fabric is thinner than expected. It's fine for summer or layering but won't keep him warm on its own. The fit is good though and he seems comfortable in it.",
    helpful: ["user1_id", "user2_id", "user3_id", "user4_id", "user5_id", "user6_id", "user7_id"]
  },
  {
    id: 116,
    productId: 30,
    userName: "Maeve Dunne",
    userHandle: "@maevedunne",
    rating: 5,
    summary: "Son loves it!",
    date: "2025-08-12",
    time: "17:10:57",
    verified: true,
    images: [],
    description: "Bought this for my 8 year old and he hasn't taken it off since. The fabric is super soft and has held up brilliantly in the wash. The colours haven't faded at all. Great quality for kids' clothing.",
    helpful: []
  },
  {
    id: 117,
    productId: 30,
    userName: "Cillian Power",
    userHandle: "@cillianpower",
    rating: 3,
    summary: "It's okay",
    date: "2024-10-10",
    time: "10:58:30",
    verified: true,
    images: [],
    description: "Not bad but the fabric is thinner than expected. It's fine for summer or layering but won't keep him warm on its own. The fit is good though and he seems comfortable in it.",
    helpful: ["user1_id", "user2_id", "user3_id", "user4_id", "user5_id", "user6_id", "user7_id"]
  },
  {
    id: 118,
    productId: 30,
    userName: "Fiona Healy",
    userHandle: "@fionahealy",
    rating: 5,
    summary: "Brilliant for school",
    date: "2025-05-01",
    time: "20:21:34",
    verified: false,
    images: [],
    description: "Perfect for layering under his school jumper. The fit is great and there's room to grow without looking oversized. Really well made — I'll definitely be buying more from this range.",
    helpful: []
  },
  {
    id: 119,
    productId: 30,
    userName: "Liam Daly",
    userHandle: "@liamdaly",
    rating: 2,
    summary: "Shrunk in the wash",
    date: "2024-06-13",
    time: "21:22:05",
    verified: false,
    images: [],
    description: "After one wash on 30 degrees it shrank noticeably. Had to size up which is annoying. The material is also pilling already. Disappointing for a brand like this.",
    helpful: ["user1_id", "user2_id"]
  },
  {
    id: 120,
    productId: 30,
    userName: "Orla Quinn",
    userHandle: "@orlaquinn",
    rating: 5,
    summary: "Brilliant for school",
    date: "2025-12-25",
    time: "12:32:50",
    verified: false,
    images: [],
    description: "Perfect for layering under his school jumper. The fit is great and there's room to grow without looking oversized. Really well made — I'll definitely be buying more from this range.",
    helpful: []
  },
  {
    id: 121,
    productId: 31,
    userName: "Darragh Keane",
    userHandle: "@darraghkeane",
    rating: 4,
    summary: "Nice quality kids' top",
    date: "2024-09-24",
    time: "13:59:23",
    verified: false,
    images: [],
    description: "Good quality fabric and well stitched. My son finds it comfortable which is the main thing. The sizing is accurate. Would have given 5 stars but the design is a bit plain for his taste.",
    helpful: ["user1_id", "user2_id", "user3_id", "user4_id", "user5_id"]
  },
  {
    id: 122,
    productId: 31,
    userName: "Aine Reilly",
    userHandle: "@ainereilly",
    rating: 4,
    summary: "Great value",
    date: "2025-12-04",
    time: "21:41:02",
    verified: false,
    images: [],
    description: "Impressed with this for the price. It washes well and dries quickly. The fit is good and my boy likes wearing it. Will pick up a couple more for the back-to-school wardrobe.",
    helpful: ["user1_id", "user2_id", "user3_id", "user4_id", "user5_id", "user6_id", "user7_id"]
  },
  {
    id: 123,
    productId: 31,
    userName: "Cathal Moran",
    userHandle: "@cathalmoran",
    rating: 4,
    summary: "Nice quality kids' top",
    date: "2025-03-07",
    time: "19:34:05",
    verified: false,
    images: [],
    description: "Good quality fabric and well stitched. My son finds it comfortable which is the main thing. The sizing is accurate. Would have given 5 stars but the design is a bit plain for his taste.",
    helpful: ["user1_id", "user2_id", "user3_id", "user4_id", "user5_id"]
  },
  {
    id: 124,
    productId: 31,
    userName: "Grainne Farrell",
    userHandle: "@grainnefarrell",
    rating: 1,
    summary: "Shrunk in the wash",
    date: "2025-02-28",
    time: "19:38:53",
    verified: true,
    images: [],
    description: "After one wash on 30 degrees it shrank noticeably. Had to size up which is annoying. The material is also pilling already. Disappointing for a brand like this.",
    helpful: ["user1_id", "user2_id", "user3_id", "user4_id"]
  },
  {
    id: 125,
    productId: 31,
    userName: "Tadhg Lynch",
    userHandle: "@tadhglynch",
    rating: 5,
    summary: "Brilliant for school",
    date: "2023-07-16",
    time: "19:43:01",
    verified: true,
    images: [],
    description: "Perfect for layering under his school jumper. The fit is great and there's room to grow without looking oversized. Really well made — I'll definitely be buying more from this range.",
    helpful: ["user1_id", "user2_id"]
  },
  {
    id: 126,
    productId: 31,
    userName: "Clodagh Murray",
    userHandle: "@clodaghmurray",
    rating: 4,
    summary: "Nice quality kids' top",
    date: "2025-11-14",
    time: "21:48:19",
    verified: true,
    images: [],
    description: "Good quality fabric and well stitched. My son finds it comfortable which is the main thing. The sizing is accurate. Would have given 5 stars but the design is a bit plain for his taste.",
    helpful: ["user1_id", "user2_id", "user3_id", "user4_id"]
  },
  {
    id: 127,
    productId: 31,
    userName: "Ronan Smyth",
    userHandle: "@ronansmyth",
    rating: 3,
    summary: "It's okay",
    date: "2024-01-04",
    time: "21:42:10",
    verified: false,
    images: [],
    description: "Not bad but the fabric is thinner than expected. It's fine for summer or layering but won't keep him warm on its own. The fit is good though and he seems comfortable in it.",
    helpful: []
  },
  {
    id: 128,
    productId: 33,
    userName: "Sinead Burke",
    userHandle: "@sineadburke",
    rating: 4,
    summary: "Nice quality kids' top",
    date: "2024-01-06",
    time: "16:33:52",
    verified: false,
    images: [],
    description: "Good quality fabric and well stitched. My son finds it comfortable which is the main thing. The sizing is accurate. Would have given 5 stars but the design is a bit plain for his taste.",
    helpful: ["user1_id", "user2_id", "user3_id", "user4_id", "user5_id", "user6_id"]
  },
  {
    id: 129,
    productId: 33,
    userName: "Fergal O'Sullivan",
    userHandle: "@fergalosullivan",
    rating: 1,
    summary: "Shrunk in the wash",
    date: "2025-06-02",
    time: "19:49:06",
    verified: true,
    images: [],
    description: "After one wash on 30 degrees it shrank noticeably. Had to size up which is annoying. The material is also pilling already. Disappointing for a brand like this.",
    helpful: ["user1_id", "user2_id", "user3_id", "user4_id", "user5_id", "user6_id", "user7_id"]
  },
  {
    id: 130,
    productId: 33,
    userName: "Deirdre Connolly",
    userHandle: "@deirdreconnolly",
    rating: 3,
    summary: "It's okay",
    date: "2024-01-15",
    time: "21:11:56",
    verified: false,
    images: [],
    description: "Not bad but the fabric is thinner than expected. It's fine for summer or layering but won't keep him warm on its own. The fit is good though and he seems comfortable in it.",
    helpful: ["user1_id", "user2_id"]
  },
  {
    id: 131,
    productId: 33,
    userName: "Killian Hughes",
    userHandle: "@killianhughes",
    rating: 5,
    summary: "Brilliant for school",
    date: "2025-08-12",
    time: "08:27:05",
    verified: true,
    images: [],
    description: "Perfect for layering under his school jumper. The fit is great and there's room to grow without looking oversized. Really well made — I'll definitely be buying more from this range.",
    helpful: ["user1_id"]
  },
  {
    id: 132,
    productId: 34,
    userName: "Emer Doherty",
    userHandle: "@emerdoherty",
    rating: 4,
    summary: "Nice quality kids' top",
    date: "2023-11-29",
    time: "21:38:35",
    verified: false,
    images: [],
    description: "Good quality fabric and well stitched. My son finds it comfortable which is the main thing. The sizing is accurate. Would have given 5 stars but the design is a bit plain for his taste.",
    helpful: []
  },
  {
    id: 133,
    productId: 34,
    userName: "Phelim Barry",
    userHandle: "@phelimbarry",
    rating: 4,
    summary: "Nice quality kids' top",
    date: "2023-11-20",
    time: "17:20:07",
    verified: true,
    images: [],
    description: "Good quality fabric and well stitched. My son finds it comfortable which is the main thing. The sizing is accurate. Would have given 5 stars but the design is a bit plain for his taste.",
    helpful: []
  },
  {
    id: 134,
    productId: 34,
    userName: "Ailbhe Whelan",
    userHandle: "@ailbhewhelan",
    rating: 5,
    summary: "Son loves it!",
    date: "2023-08-03",
    time: "13:02:08",
    verified: true,
    images: [],
    description: "Bought this for my 8 year old and he hasn't taken it off since. The fabric is super soft and has held up brilliantly in the wash. The colours haven't faded at all. Great quality for kids' clothing.",
    helpful: []
  },
  {
    id: 135,
    productId: 34,
    userName: "Tiernan Kenny",
    userHandle: "@tiernankenny",
    rating: 5,
    summary: "Son loves it!",
    date: "2025-09-06",
    time: "10:40:48",
    verified: true,
    images: [],
    description: "Bought this for my 8 year old and he hasn't taken it off since. The fabric is super soft and has held up brilliantly in the wash. The colours haven't faded at all. Great quality for kids' clothing.",
    helpful: ["user1_id", "user2_id", "user3_id", "user4_id", "user5_id"]
  },
  {
    id: 136,
    productId: 34,
    userName: "Bronagh Casey",
    userHandle: "@bronaghcasey",
    rating: 5,
    summary: "Son loves it!",
    date: "2026-01-10",
    time: "17:43:11",
    verified: true,
    images: [],
    description: "Bought this for my 8 year old and he hasn't taken it off since. The fabric is super soft and has held up brilliantly in the wash. The colours haven't faded at all. Great quality for kids' clothing.",
    helpful: []
  },
  {
    id: 137,
    productId: 34,
    userName: "Fintan Sheehan",
    userHandle: "@fintansheehan",
    rating: 5,
    summary: "Son loves it!",
    date: "2024-08-05",
    time: "17:25:52",
    verified: false,
    images: [],
    description: "Bought this for my 8 year old and he hasn't taken it off since. The fabric is super soft and has held up brilliantly in the wash. The colours haven't faded at all. Great quality for kids' clothing.",
    helpful: ["user1_id", "user2_id", "user3_id"]
  },
  {
    id: 138,
    productId: 34,
    userName: "Muireann Long",
    userHandle: "@muireannlong",
    rating: 5,
    summary: "Brilliant for school",
    date: "2023-06-25",
    time: "12:30:14",
    verified: false,
    images: [],
    description: "Perfect for layering under his school jumper. The fit is great and there's room to grow without looking oversized. Really well made — I'll definitely be buying more from this range.",
    helpful: ["user1_id", "user2_id", "user3_id", "user4_id", "user5_id", "user6_id"]
  },
  {
    id: 139,
    productId: 34,
    userName: "Daire Griffin",
    userHandle: "@dairegriffin",
    rating: 4,
    summary: "Nice quality kids' top",
    date: "2023-10-15",
    time: "19:03:40",
    verified: false,
    images: [],
    description: "Good quality fabric and well stitched. My son finds it comfortable which is the main thing. The sizing is accurate. Would have given 5 stars but the design is a bit plain for his taste.",
    helpful: ["user1_id", "user2_id", "user3_id", "user4_id", "user5_id", "user6_id", "user7_id"]
  },
  {
    id: 140,
    productId: 35,
    userName: "Sorcha Flynn",
    userHandle: "@sorchaflynn",
    rating: 5,
    summary: "Son loves it!",
    date: "2023-11-17",
    time: "10:32:41",
    verified: true,
    images: [],
    description: "Bought this for my 8 year old and he hasn't taken it off since. The fabric is super soft and has held up brilliantly in the wash. The colours haven't faded at all. Great quality for kids' clothing.",
    helpful: ["user1_id", "user2_id", "user3_id", "user4_id", "user5_id", "user6_id", "user7_id"]
  },
  {
    id: 141,
    productId: 35,
    userName: "Lorcan Duffy",
    userHandle: "@lorcanduffy",
    rating: 4,
    summary: "Great value",
    date: "2025-02-06",
    time: "15:38:43",
    verified: false,
    images: [],
    description: "Impressed with this for the price. It washes well and dries quickly. The fit is good and my boy likes wearing it. Will pick up a couple more for the back-to-school wardrobe.",
    helpful: []
  },
  {
    id: 142,
    productId: 36,
    userName: "Rachel Moore",
    userHandle: "@rachelmoore",
    rating: 3,
    summary: "It's okay",
    date: "2023-06-11",
    time: "18:14:06",
    verified: false,
    images: [],
    description: "Not bad but the fabric is thinner than expected. It's fine for summer or layering but won't keep him warm on its own. The fit is good though and he seems comfortable in it.",
    helpful: ["user1_id", "user2_id", "user3_id"]
  },
  {
    id: 143,
    productId: 36,
    userName: "Tom Henderson",
    userHandle: "@tomhenderson",
    rating: 2,
    summary: "Shrunk in the wash",
    date: "2023-06-11",
    time: "14:40:09",
    verified: false,
    images: [],
    description: "After one wash on 30 degrees it shrank noticeably. Had to size up which is annoying. The material is also pilling already. Disappointing for a brand like this.",
    helpful: []
  },
  {
    id: 144,
    productId: 36,
    userName: "Sarah Donahue",
    userHandle: "@sarahdonahue",
    rating: 1,
    summary: "Shrunk in the wash",
    date: "2024-07-13",
    time: "14:25:40",
    verified: true,
    images: [],
    description: "After one wash on 30 degrees it shrank noticeably. Had to size up which is annoying. The material is also pilling already. Disappointing for a brand like this.",
    helpful: ["user1_id", "user2_id", "user3_id", "user4_id", "user5_id"]
  },
  {
    id: 145,
    productId: 37,
    userName: "Mark O'Connell",
    userHandle: "@markoconnell",
    rating: 5,
    summary: "Beautiful outfit",
    date: "2025-10-20",
    time: "13:37:55",
    verified: false,
    images: [],
    description: "The colours are lovely and the ruffles are a sweet detail. My girl absolutely loves twirling in this. It washed beautifully and came out looking brand new. Would highly recommend.",
    helpful: ["user1_id", "user2_id", "user3_id", "user4_id", "user5_id", "user6_id"]
  },
  {
    id: 146,
    productId: 37,
    userName: "Hannah Taylor",
    userHandle: "@hannahtaylor",
    rating: 4,
    summary: "Lovely design",
    date: "2025-11-30",
    time: "19:50:00",
    verified: false,
    images: [],
    description: "The quality is great and my daughter loves the pattern. It's easy to put on and take off which is a bonus with young kids. A nice addition to her wardrobe.",
    helpful: ["user1_id", "user2_id", "user3_id"]
  },
  {
    id: 147,
    productId: 37,
    userName: "Ben Collins",
    userHandle: "@bencollins",
    rating: 3,
    summary: "Cute but runs small",
    date: "2025-04-11",
    time: "10:01:14",
    verified: true,
    images: [],
    description: "Had to return and size up. The design is sweet and the fabric is decent but the sizing is definitely on the smaller side. Order a size up from your child's usual.",
    helpful: ["user1_id", "user2_id", "user3_id", "user4_id", "user5_id", "user6_id", "user7_id"]
  },
  {
    id: 148,
    productId: 37,
    userName: "Lucy Bennett",
    userHandle: "@lucybennett",
    rating: 3,
    summary: "Cute but runs small",
    date: "2026-01-02",
    time: "20:36:36",
    verified: false,
    images: [],
    description: "Had to return and size up. The design is sweet and the fabric is decent but the sizing is definitely on the smaller side. Order a size up from your child's usual.",
    helpful: ["user1_id", "user2_id"]
  },
  {
    id: 149,
    productId: 37,
    userName: "James Ward",
    userHandle: "@jamesward",
    rating: 5,
    summary: "Beautiful outfit",
    date: "2025-12-16",
    time: "12:10:52",
    verified: true,
    images: [],
    description: "The colours are lovely and the ruffles are a sweet detail. My girl absolutely loves twirling in this. It washed beautifully and came out looking brand new. Would highly recommend.",
    helpful: []
  },
  {
    id: 150,
    productId: 37,
    userName: "Emily Clarke",
    userHandle: "@emilyclarke",
    rating: 4,
    summary: "Lovely design",
    date: "2025-06-30",
    time: "10:02:05",
    verified: false,
    images: [],
    description: "The quality is great and my daughter loves the pattern. It's easy to put on and take off which is a bonus with young kids. A nice addition to her wardrobe.",
    helpful: ["user1_id", "user2_id", "user3_id"]
  },
  {
    id: 151,
    productId: 37,
    userName: "Sean Murphy",
    userHandle: "@seanmurphy",
    rating: 4,
    summary: "Lovely design",
    date: "2025-03-17",
    time: "17:26:55",
    verified: true,
    images: [],
    description: "The quality is great and my daughter loves the pattern. It's easy to put on and take off which is a bonus with young kids. A nice addition to her wardrobe.",
    helpful: ["user1_id", "user2_id", "user3_id", "user4_id", "user5_id"]
  },
  {
    id: 152,
    productId: 37,
    userName: "Aoife Byrne",
    userHandle: "@aoifebyrne",
    rating: 2,
    summary: "Colours faded quickly",
    date: "2023-10-03",
    time: "18:57:53",
    verified: false,
    images: [],
    description: "After just two washes the colours have faded quite a bit which is disappointing. The fit is also quite tight around the arms. My daughter finds it uncomfortable now.",
    helpful: ["user1_id"]
  },
  {
    id: 153,
    productId: 39,
    userName: "Ciaran Kelly",
    userHandle: "@ciarankelly",
    rating: 5,
    summary: "She looked adorable!",
    date: "2024-09-07",
    time: "19:00:17",
    verified: false,
    images: [],
    description: "My daughter wore this to a birthday party and got so many compliments. The fabric is soft and she was comfortable running around all day. The design is beautiful and the quality is excellent for the price.",
    helpful: ["user1_id", "user2_id"]
  },
  {
    id: 154,
    productId: 39,
    userName: "Niamh Walsh",
    userHandle: "@niamhwalsh",
    rating: 5,
    summary: "She looked adorable!",
    date: "2023-06-05",
    time: "14:14:01",
    verified: false,
    images: [],
    description: "My daughter wore this to a birthday party and got so many compliments. The fabric is soft and she was comfortable running around all day. The design is beautiful and the quality is excellent for the price.",
    helpful: []
  },
  {
    id: 155,
    productId: 39,
    userName: "Declan Ryan",
    userHandle: "@declanryan",
    rating: 4,
    summary: "Lovely design",
    date: "2024-11-25",
    time: "12:49:22",
    verified: true,
    images: [],
    description: "The quality is great and my daughter loves the pattern. It's easy to put on and take off which is a bonus with young kids. A nice addition to her wardrobe.",
    helpful: []
  },
  {
    id: 156,
    productId: 39,
    userName: "Siobhan O'Brien",
    userHandle: "@siobhanobrien",
    rating: 2,
    summary: "Colours faded quickly",
    date: "2025-02-20",
    time: "10:48:02",
    verified: true,
    images: [],
    description: "After just two washes the colours have faded quite a bit which is disappointing. The fit is also quite tight around the arms. My daughter finds it uncomfortable now.",
    helpful: []
  },
  {
    id: 157,
    productId: 39,
    userName: "Padraig Doyle",
    userHandle: "@padraigdoyle",
    rating: 3,
    summary: "Cute but runs small",
    date: "2025-03-22",
    time: "12:55:45",
    verified: true,
    images: [],
    description: "Had to return and size up. The design is sweet and the fabric is decent but the sizing is definitely on the smaller side. Order a size up from your child's usual.",
    helpful: ["user1_id", "user2_id", "user3_id", "user4_id"]
  },
  {
    id: 158,
    productId: 41,
    userName: "Roisin Gallagher",
    userHandle: "@roisingallagher",
    rating: 5,
    summary: "Great for school",
    date: "2023-06-08",
    time: "21:24:31",
    verified: true,
    images: [],
    description: "Perfect shirt for school. It's well made and my daughter finds it comfortable to wear all day. Easy to iron and the fabric holds up well wash after wash.",
    helpful: []
  },
  {
    id: 159,
    productId: 41,
    userName: "Conor Fitzgerald",
    userHandle: "@conorfitzgerald",
    rating: 5,
    summary: "Great for school",
    date: "2024-07-13",
    time: "14:45:39",
    verified: false,
    images: [],
    description: "Perfect shirt for school. It's well made and my daughter finds it comfortable to wear all day. Easy to iron and the fabric holds up well wash after wash.",
    helpful: []
  },
  {
    id: 160,
    productId: 41,
    userName: "Saoirse Brennan",
    userHandle: "@saoirsebrennan",
    rating: 1,
    summary: "It's fine",
    date: "2023-06-14",
    time: "13:42:37",
    verified: true,
    images: [],
    description: "Decent enough shirt for the price. The fabric is okay, nothing amazing. My daughter doesn't complain about it which I suppose is a good sign. Does the job.",
    helpful: ["user1_id", "user2_id", "user3_id", "user4_id"]
  },
  {
    id: 161,
    productId: 41,
    userName: "Eoin McCarthy",
    userHandle: "@eoinmccarthy",
    rating: 3,
    summary: "It's fine",
    date: "2026-01-30",
    time: "10:00:53",
    verified: false,
    images: [],
    description: "Decent enough shirt for the price. The fabric is okay, nothing amazing. My daughter doesn't complain about it which I suppose is a good sign. Does the job.",
    helpful: ["user1_id", "user2_id", "user3_id"]
  },
  {
    id: 162,
    productId: 41,
    userName: "Caoimhe Nolan",
    userHandle: "@caoimhenolan",
    rating: 5,
    summary: "Great for school",
    date: "2024-03-27",
    time: "16:32:01",
    verified: true,
    images: [],
    description: "Perfect shirt for school. It's well made and my daughter finds it comfortable to wear all day. Easy to iron and the fabric holds up well wash after wash.",
    helpful: ["user1_id", "user2_id", "user3_id"]
  },
  {
    id: 163,
    productId: 41,
    userName: "Oisin Kavanagh",
    userHandle: "@oisinkavanagh",
    rating: 4,
    summary: "Happy with this",
    date: "2025-01-30",
    time: "09:12:31",
    verified: true,
    images: [],
    description: "Bought two of these — one for school and one for weekends. They're well made and the colours are true to the pictures. Good value for the price.",
    helpful: ["user1_id", "user2_id", "user3_id", "user4_id", "user5_id", "user6_id", "user7_id"]
  },
  {
    id: 164,
    productId: 41,
    userName: "Maeve Dunne",
    userHandle: "@maevedunne",
    rating: 5,
    summary: "Great for school",
    date: "2025-10-08",
    time: "17:46:08",
    verified: false,
    images: [],
    description: "Perfect shirt for school. It's well made and my daughter finds it comfortable to wear all day. Easy to iron and the fabric holds up well wash after wash.",
    helpful: []
  },
  {
    id: 165,
    productId: 42,
    userName: "Cillian Power",
    userHandle: "@cillianpower",
    rating: 5,
    summary: "Gorgeous skirt!",
    date: "2024-02-13",
    time: "10:24:55",
    verified: true,
    images: [],
    description: "The plaid pattern is beautiful and the high waist is very flattering. My daughter paired it with tights and a jumper and it looked lovely. Really well made with neat stitching throughout.",
    helpful: ["user1_id", "user2_id", "user3_id", "user4_id", "user5_id"]
  },
  {
    id: 166,
    productId: 42,
    userName: "Fiona Healy",
    userHandle: "@fionahealy",
    rating: 5,
    summary: "Gorgeous skirt!",
    date: "2023-07-20",
    time: "12:27:00",
    verified: false,
    images: [],
    description: "The plaid pattern is beautiful and the high waist is very flattering. My daughter paired it with tights and a jumper and it looked lovely. Really well made with neat stitching throughout.",
    helpful: ["user1_id", "user2_id", "user3_id"]
  },
  {
    id: 167,
    productId: 42,
    userName: "Liam Daly",
    userHandle: "@liamdaly",
    rating: 4,
    summary: "Pretty and well made",
    date: "2025-03-18",
    time: "19:49:45",
    verified: false,
    images: [],
    description: "Nice quality skirt at a reasonable price. The plaid pattern is classic and the fit is good. My daughter likes wearing it for school and casual outings.",
    helpful: ["user1_id", "user2_id", "user3_id", "user4_id"]
  },
  {
    id: 168,
    productId: 42,
    userName: "Orla Quinn",
    userHandle: "@orlaquinn",
    rating: 5,
    summary: "Gorgeous skirt!",
    date: "2024-10-22",
    time: "13:14:41",
    verified: true,
    images: [],
    description: "The plaid pattern is beautiful and the high waist is very flattering. My daughter paired it with tights and a jumper and it looked lovely. Really well made with neat stitching throughout.",
    helpful: []
  },
  {
    id: 169,
    productId: 42,
    userName: "Darragh Keane",
    userHandle: "@darraghkeane",
    rating: 3,
    summary: "Decent skirt",
    date: "2024-03-08",
    time: "09:47:07",
    verified: false,
    images: [],
    description: "It's okay. The fabric is a bit thin and I'm not sure how long it will last with regular wear. The pattern is nice though and the waistband is comfortable.",
    helpful: []
  },
  {
    id: 170,
    productId: 42,
    userName: "Aine Reilly",
    userHandle: "@ainereilly",
    rating: 2,
    summary: "Decent skirt",
    date: "2025-04-29",
    time: "16:20:50",
    verified: true,
    images: [],
    description: "It's okay. The fabric is a bit thin and I'm not sure how long it will last with regular wear. The pattern is nice though and the waistband is comfortable.",
    helpful: []
  },
  {
    id: 171,
    productId: 42,
    userName: "Cathal Moran",
    userHandle: "@cathalmoran",
    rating: 5,
    summary: "Gorgeous skirt!",
    date: "2024-08-26",
    time: "12:01:47",
    verified: false,
    images: [],
    description: "The plaid pattern is beautiful and the high waist is very flattering. My daughter paired it with tights and a jumper and it looked lovely. Really well made with neat stitching throughout.",
    helpful: ["user1_id", "user2_id", "user3_id", "user4_id", "user5_id", "user6_id", "user7_id"]
  },
  {
    id: 172,
    productId: 42,
    userName: "Grainne Farrell",
    userHandle: "@grainnefarrell",
    rating: 5,
    summary: "Gorgeous skirt!",
    date: "2023-07-06",
    time: "09:52:39",
    verified: true,
    images: [],
    description: "The plaid pattern is beautiful and the high waist is very flattering. My daughter paired it with tights and a jumper and it looked lovely. Really well made with neat stitching throughout.",
    helpful: []
  },
  {
    id: 173,
    productId: 43,
    userName: "Tadhg Lynch",
    userHandle: "@tadhglynch",
    rating: 3,
    summary: "Cute but runs small",
    date: "2024-12-15",
    time: "20:42:11",
    verified: false,
    images: [],
    description: "Had to return and size up. The design is sweet and the fabric is decent but the sizing is definitely on the smaller side. Order a size up from your child's usual.",
    helpful: []
  },
  {
    id: 174,
    productId: 43,
    userName: "Clodagh Murray",
    userHandle: "@clodaghmurray",
    rating: 5,
    summary: "She looked adorable!",
    date: "2023-10-16",
    time: "11:32:31",
    verified: false,
    images: [],
    description: "My daughter wore this to a birthday party and got so many compliments. The fabric is soft and she was comfortable running around all day. The design is beautiful and the quality is excellent for the price.",
    helpful: []
  },
  {
    id: 175,
    productId: 43,
    userName: "Ronan Smyth",
    userHandle: "@ronansmyth",
    rating: 4,
    summary: "Lovely design",
    date: "2025-04-20",
    time: "13:55:53",
    verified: true,
    images: [],
    description: "The quality is great and my daughter loves the pattern. It's easy to put on and take off which is a bonus with young kids. A nice addition to her wardrobe.",
    helpful: ["user1_id", "user2_id", "user3_id", "user4_id", "user5_id", "user6_id", "user7_id"]
  },
  {
    id: 176,
    productId: 43,
    userName: "Sinead Burke",
    userHandle: "@sineadburke",
    rating: 2,
    summary: "Colours faded quickly",
    date: "2023-10-18",
    time: "18:19:15",
    verified: true,
    images: [],
    description: "After just two washes the colours have faded quite a bit which is disappointing. The fit is also quite tight around the arms. My daughter finds it uncomfortable now.",
    helpful: ["user1_id", "user2_id", "user3_id", "user4_id", "user5_id"]
  },
  {
    id: 177,
    productId: 43,
    userName: "Fergal O'Sullivan",
    userHandle: "@fergalosullivan",
    rating: 1,
    summary: "Colours faded quickly",
    date: "2024-02-22",
    time: "16:20:47",
    verified: false,
    images: [],
    description: "After just two washes the colours have faded quite a bit which is disappointing. The fit is also quite tight around the arms. My daughter finds it uncomfortable now.",
    helpful: []
  },
  {
    id: 178,
    productId: 43,
    userName: "Deirdre Connolly",
    userHandle: "@deirdreconnolly",
    rating: 3,
    summary: "Cute but runs small",
    date: "2025-07-19",
    time: "14:11:48",
    verified: true,
    images: [],
    description: "Had to return and size up. The design is sweet and the fabric is decent but the sizing is definitely on the smaller side. Order a size up from your child's usual.",
    helpful: ["user1_id"]
  },
  {
    id: 179,
    productId: 43,
    userName: "Killian Hughes",
    userHandle: "@killianhughes",
    rating: 5,
    summary: "She looked adorable!",
    date: "2026-01-28",
    time: "11:45:24",
    verified: false,
    images: [],
    description: "My daughter wore this to a birthday party and got so many compliments. The fabric is soft and she was comfortable running around all day. The design is beautiful and the quality is excellent for the price.",
    helpful: ["user1_id", "user2_id", "user3_id", "user4_id"]
  },
  {
    id: 180,
    productId: 1,
    userName: "Aoibheann Flanagan",
    userHandle: "@aoibheannflanagan",
    rating: 5,
    summary: "Cannot fault this at all",
    date: "2023-08-07",
    time: "10:14:55",
    verified: true,
    images: [],
    description: "One of the nicest pieces I've bought this year. The material feels expensive, the stitching is immaculate and the colour is gorgeous in person. I've washed it three times already and it still looks brand new. Will definitely be buying more.",
    helpful: ["user1_id", "user2_id", "user3_id", "user4_id", "user5_id"]
  },
  {
    id: 181,
    productId: 1,
    userName: "Colm Tierney",
    userHandle: "@colmtierney",
    rating: 5,
    summary: "Worth every penny",
    date: "2023-08-20",
    time: "20:41:11",
    verified: false,
    images: [],
    description: "I debated for a while before buying this but I'm so glad I did. It's incredibly soft and drapes beautifully. I've received multiple compliments already. The fit is spot on — I got my usual size and it's perfect.",
    helpful: []
  },
  {
    id: 182,
    productId: 1,
    userName: "Meadhbh Sweeney",
    userHandle: "@meadhbhsweeney",
    rating: 5,
    summary: "Gorgeous and comfortable",
    date: "2025-03-31",
    time: "12:47:15",
    verified: true,
    images: [],
    description: "Really lovely piece. It's cozy and warm, perfect for autumn layering. The colour is true to the pictures online. Very happy with this purchase — it's become a wardrobe staple.",
    helpful: []
  },
  {
    id: 183,
    productId: 1,
    userName: "Ruairi Chambers",
    userHandle: "@ruairichambers",
    rating: 3,
    summary: "Nice but not amazing",
    date: "2023-04-18",
    time: "09:54:14",
    verified: true,
    images: [],
    description: "It's a decent piece for the price but I wouldn't say it blew me away. The fabric is okay — not as plush as I'd hoped from the description. The fit is fine and it looks presentable enough.",
    helpful: ["user1_id", "user2_id", "user3_id", "user4_id", "user5_id", "user6_id", "user7_id", "user8_id"]
  },
  {
    id: 184,
    productId: 1,
    userName: "Cliona Madden",
    userHandle: "@clionamadden",
    rating: 5,
    summary: "My new favourite sweater",
    date: "2025-02-26",
    time: "11:23:36",
    verified: true,
    images: [],
    description: "I wear this constantly. It goes with everything in my wardrobe and is comfortable enough for all day wear. The fabric has a lovely drape and doesn't cling in unflattering places. Highly recommend.",
    helpful: ["user1_id", "user2_id", "user3_id", "user4_id", "user5_id", "user6_id", "user7_id"]
  },
  {
    id: 185,
    productId: 1,
    userName: "Diarmuid Foley",
    userHandle: "@diarmuidfoley",
    rating: 4,
    summary: "Smart casual perfection",
    date: "2024-05-30",
    time: "10:01:18",
    verified: false,
    images: [],
    description: "This works brilliantly for the office or weekends. The fabric has a lovely weight to it and doesn't wrinkle. I've paired it with tailored trousers and with jeans — works with both. Very pleased.",
    helpful: []
  },
  {
    id: 186,
    productId: 1,
    userName: "Eimear Tobin",
    userHandle: "@eimeartobin",
    rating: 3,
    summary: "Runs a bit small",
    date: "2023-11-28",
    time: "19:33:57",
    verified: true,
    images: [],
    description: "Had to size up which was a pain. Once I got the right size the quality is decent and the colour is nice. It's comfortable but I wouldn't call it exceptional. Fine for everyday wear.",
    helpful: ["user1_id", "user2_id", "user3_id"]
  },
  {
    id: 187,
    productId: 1,
    userName: "Fiachra Lowe",
    userHandle: "@fiachralowe",
    rating: 5,
    summary: "Obsessed with this!",
    date: "2024-03-21",
    time: "21:34:02",
    verified: true,
    images: [],
    description: "This is hands down the best knitwear purchase I've made in ages. It's warm without being bulky, looks chic with everything and the quality is outstanding. Already planning to get another colour.",
    helpful: ["user1_id", "user2_id", "user3_id", "user4_id", "user5_id"]
  },
  {
    id: 188,
    productId: 1,
    userName: "Ide Callaghan",
    userHandle: "@idecallaghan",
    rating: 4,
    summary: "Great addition to my wardrobe",
    date: "2023-01-07",
    time: "12:00:27",
    verified: false,
    images: [],
    description: "Really pleased with this. It's versatile enough to dress up or down and the material is soft and comfortable. The length is perfect for me at 5'5. Knocked off a star as it pills slightly under the arms.",
    helpful: ["user1_id", "user2_id", "user3_id", "user4_id", "user5_id", "user6_id"]
  },
  {
    id: 189,
    productId: 2,
    userName: "Jarlath Hickey",
    userHandle: "@jarlathhickey",
    rating: 5,
    summary: "Obsessed with this!",
    date: "2023-03-09",
    time: "21:58:12",
    verified: true,
    images: [],
    description: "This is hands down the best knitwear purchase I've made in ages. It's warm without being bulky, looks chic with everything and the quality is outstanding. Already planning to get another colour.",
    helpful: ["user1_id", "user2_id"]
  },
  {
    id: 190,
    productId: 2,
    userName: "Keelin Roche",
    userHandle: "@keelinroche",
    rating: 3,
    summary: "Nice but not amazing",
    date: "2024-06-18",
    time: "16:40:22",
    verified: true,
    images: [],
    description: "It's a decent piece for the price but I wouldn't say it blew me away. The fabric is okay — not as plush as I'd hoped from the description. The fit is fine and it looks presentable enough.",
    helpful: []
  },
  {
    id: 191,
    productId: 2,
    userName: "Lorcan Phelan",
    userHandle: "@lorcanphelan",
    rating: 2,
    summary: "Pilled after first wash",
    date: "2024-11-26",
    time: "20:38:46",
    verified: false,
    images: [],
    description: "Was really looking forward to wearing this but it pilled all over after just one gentle wash. The quality doesn't match the price at all. The fit was also larger than expected. Disappointed.",
    helpful: []
  },
  {
    id: 192,
    productId: 2,
    userName: "Muirne Dempsey",
    userHandle: "@muirnedempsey",
    rating: 2,
    summary: "Colour was way off",
    date: "2023-03-18",
    time: "20:16:23",
    verified: false,
    images: [],
    description: "The colour I received looks nothing like the photos. What should have been a rich tone is actually quite dull and washed out. The material is also thinner than it appeared. Won't be keeping this.",
    helpful: ["user1_id", "user2_id"]
  },
  {
    id: 193,
    productId: 2,
    userName: "Naoise Behan",
    userHandle: "@naoisebehan",
    rating: 4,
    summary: "Love it, minor fit issue",
    date: "2024-02-05",
    time: "18:18:56",
    verified: true,
    images: [],
    description: "Beautiful quality and really flattering on. The only thing is the arms are slightly tight if you have broader shoulders like me. I sized up and it fits much better. The fabric is luxurious and the colour is lovely.",
    helpful: []
  },
  {
    id: 194,
    productId: 3,
    userName: "Odhrán Hogan",
    userHandle: "@odhranhogan",
    rating: 2,
    summary: "Pilled after first wash",
    date: "2025-08-03",
    time: "21:04:48",
    verified: false,
    images: [],
    description: "Was really looking forward to wearing this but it pilled all over after just one gentle wash. The quality doesn't match the price at all. The fit was also larger than expected. Disappointed.",
    helpful: ["user1_id", "user2_id", "user3_id", "user4_id"]
  },
  {
    id: 195,
    productId: 3,
    userName: "Peig Corcoran",
    userHandle: "@peigcorcoran",
    rating: 4,
    summary: "Smart casual perfection",
    date: "2023-08-28",
    time: "21:30:57",
    verified: false,
    images: [],
    description: "This works brilliantly for the office or weekends. The fabric has a lovely weight to it and doesn't wrinkle. I've paired it with tailored trousers and with jeans — works with both. Very pleased.",
    helpful: ["user1_id", "user2_id", "user3_id", "user4_id", "user5_id"]
  },
  {
    id: 196,
    productId: 3,
    userName: "Rian Ennis",
    userHandle: "@rianennis",
    rating: 4,
    summary: "Great addition to my wardrobe",
    date: "2025-10-30",
    time: "18:35:24",
    verified: false,
    images: [],
    description: "Really pleased with this. It's versatile enough to dress up or down and the material is soft and comfortable. The length is perfect for me at 5'5. Knocked off a star as it pills slightly under the arms.",
    helpful: []
  },
  {
    id: 197,
    productId: 3,
    userName: "Sadhbh Coughlan",
    userHandle: "@sadhbhcoughlan",
    rating: 3,
    summary: "Nice but not amazing",
    date: "2023-12-02",
    time: "09:06:18",
    verified: false,
    images: [],
    description: "It's a decent piece for the price but I wouldn't say it blew me away. The fabric is okay — not as plush as I'd hoped from the description. The fit is fine and it looks presentable enough.",
    helpful: ["user1_id", "user2_id", "user3_id", "user4_id", "user5_id", "user6_id", "user7_id", "user8_id"]
  },
  {
    id: 198,
    productId: 3,
    userName: "Turlough Breen",
    userHandle: "@turloughbreen",
    rating: 5,
    summary: "Obsessed with this!",
    date: "2025-03-22",
    time: "13:44:31",
    verified: false,
    images: [],
    description: "This is hands down the best knitwear purchase I've made in ages. It's warm without being bulky, looks chic with everything and the quality is outstanding. Already planning to get another colour.",
    helpful: []
  },
  {
    id: 199,
    productId: 3,
    userName: "Una Costello",
    userHandle: "@unacostello",
    rating: 5,
    summary: "Worth every penny",
    date: "2023-11-29",
    time: "09:52:36",
    verified: false,
    images: [],
    description: "I debated for a while before buying this but I'm so glad I did. It's incredibly soft and drapes beautifully. I've received multiple compliments already. The fit is spot on — I got my usual size and it's perfect.",
    helpful: ["user1_id", "user2_id", "user3_id", "user4_id", "user5_id", "user6_id", "user7_id"]
  },
  {
    id: 200,
    productId: 4,
    userName: "Blathnaid Kirwan",
    userHandle: "@blathnaidkirwan",
    rating: 4,
    summary: "Lovely quality for the price",
    date: "2025-11-26",
    time: "18:37:01",
    verified: false,
    images: [],
    description: "Impressed with how well this is made. The seams are neat, the fabric is substantial and the fit is flattering. It does attract a bit of lint which is annoying but otherwise a great purchase.",
    helpful: ["user1_id", "user2_id", "user3_id"]
  },
  {
    id: 201,
    productId: 4,
    userName: "Criostoir Harkin",
    userHandle: "@cristoirharkin",
    rating: 3,
    summary: "Expected more for the price",
    date: "2023-01-18",
    time: "19:06:01",
    verified: false,
    images: [],
    description: "It's not bad by any means but it doesn't feel like premium quality. The colour is slightly different from the photos — more muted in real life. It's comfortable though and serves its purpose.",
    helpful: ["user1_id"]
  },
  {
    id: 202,
    productId: 4,
    userName: "Doireann Buckley",
    userHandle: "@doireannbuckley",
    rating: 5,
    summary: "Cannot fault this at all",
    date: "2025-10-20",
    time: "12:41:25",
    verified: false,
    images: [],
    description: "One of the nicest pieces I've bought this year. The material feels expensive, the stitching is immaculate and the colour is gorgeous in person. I've washed it three times already and it still looks brand new. Will definitely be buying more.",
    helpful: []
  },
  {
    id: 203,
    productId: 5,
    userName: "Eanna Moloney",
    userHandle: "@eannamoloney",
    rating: 3,
    summary: "Expected more for the price",
    date: "2025-02-17",
    time: "15:45:08",
    verified: false,
    images: [],
    description: "It's not bad by any means but it doesn't feel like premium quality. The colour is slightly different from the photos — more muted in real life. It's comfortable though and serves its purpose.",
    helpful: ["user1_id", "user2_id", "user3_id", "user4_id", "user5_id"]
  },
  {
    id: 204,
    productId: 6,
    userName: "Gormlaith Stack",
    userHandle: "@gormlathstack",
    rating: 2,
    summary: "Colour was way off",
    date: "2023-04-22",
    time: "20:22:16",
    verified: true,
    images: [],
    description: "The colour I received looks nothing like the photos. What should have been a rich tone is actually quite dull and washed out. The material is also thinner than it appeared. Won't be keeping this.",
    helpful: []
  },
  {
    id: 205,
    productId: 6,
    userName: "Iarlaith Devlin",
    userHandle: "@iarlathdevlin",
    rating: 4,
    summary: "Lovely quality for the price",
    date: "2024-03-22",
    time: "18:53:24",
    verified: false,
    images: [],
    description: "Impressed with how well this is made. The seams are neat, the fabric is substantial and the fit is flattering. It does attract a bit of lint which is annoying but otherwise a great purchase.",
    helpful: ["user1_id", "user2_id", "user3_id", "user4_id", "user5_id", "user6_id"]
  },
  {
    id: 206,
    productId: 6,
    userName: "Laoise Donovan",
    userHandle: "@laoisedonovan",
    rating: 3,
    summary: "Nice but not amazing",
    date: "2023-03-17",
    time: "13:28:04",
    verified: false,
    images: [],
    description: "It's a decent piece for the price but I wouldn't say it blew me away. The fabric is okay — not as plush as I'd hoped from the description. The fit is fine and it looks presentable enough.",
    helpful: ["user1_id"]
  },
  {
    id: 207,
    productId: 6,
    userName: "Malachy Geraghty",
    userHandle: "@malachygeraghty",
    rating: 5,
    summary: "Worth every penny",
    date: "2023-12-26",
    time: "18:20:12",
    verified: false,
    images: [],
    description: "I debated for a while before buying this but I'm so glad I did. It's incredibly soft and drapes beautifully. I've received multiple compliments already. The fit is spot on — I got my usual size and it's perfect.",
    helpful: ["user1_id", "user2_id", "user3_id", "user4_id", "user5_id", "user6_id"]
  },
  {
    id: 208,
    productId: 6,
    userName: "Neasa Tully",
    userHandle: "@neasatully",
    rating: 1,
    summary: "Falling apart already",
    date: "2024-11-16",
    time: "15:17:57",
    verified: false,
    images: [],
    description: "Worn this twice and the seam on the shoulder is already coming undone. The fabric feels cheap and scratchy. Really poor quality for the price — I expected much better. Returning immediately.",
    helpful: []
  },
  {
    id: 209,
    productId: 6,
    userName: "Odhran Kelly",
    userHandle: "@odhrankelly",
    rating: 4,
    summary: "Lovely quality for the price",
    date: "2025-02-18",
    time: "10:21:00",
    verified: true,
    images: [],
    description: "Impressed with how well this is made. The seams are neat, the fabric is substantial and the fit is flattering. It does attract a bit of lint which is annoying but otherwise a great purchase.",
    helpful: []
  },
  {
    id: 210,
    productId: 6,
    userName: "Proinnsias Noonan",
    userHandle: "@proinnsiasnonan",
    rating: 4,
    summary: "Smart casual perfection",
    date: "2025-08-28",
    time: "12:43:45",
    verified: true,
    images: [],
    description: "This works brilliantly for the office or weekends. The fabric has a lovely weight to it and doesn't wrinkle. I've paired it with tailored trousers and with jeans — works with both. Very pleased.",
    helpful: []
  },
  {
    id: 211,
    productId: 6,
    userName: "Rowan McEvoy",
    userHandle: "@rowanmcevoy",
    rating: 4,
    summary: "Lovely quality for the price",
    date: "2025-12-12",
    time: "11:19:08",
    verified: true,
    images: [],
    description: "Impressed with how well this is made. The seams are neat, the fabric is substantial and the fit is flattering. It does attract a bit of lint which is annoying but otherwise a great purchase.",
    helpful: []
  },
  {
    id: 212,
    productId: 7,
    userName: "Sibeal Crowe",
    userHandle: "@sibealcrowe",
    rating: 4,
    summary: "Really nice, runs slightly small",
    date: "2026-01-31",
    time: "18:08:06",
    verified: false,
    images: [],
    description: "The quality and design are lovely but I'd recommend sizing up. I normally wear a M and this was quite snug. Exchanged for an L and it's perfect now. Beautiful colour and great fabric.",
    helpful: ["user1_id", "user2_id", "user3_id", "user4_id", "user5_id"]
  },
  {
    id: 213,
    productId: 7,
    userName: "Tiernan Fallon",
    userHandle: "@tiernanfallon",
    rating: 4,
    summary: "Really nice, runs slightly small",
    date: "2025-01-15",
    time: "10:02:43",
    verified: true,
    images: [],
    description: "The quality and design are lovely but I'd recommend sizing up. I normally wear a M and this was quite snug. Exchanged for an L and it's perfect now. Beautiful colour and great fabric.",
    helpful: ["user1_id", "user2_id", "user3_id", "user4_id", "user5_id", "user6_id", "user7_id", "user8_id", "user9_id"]
  },
  {
    id: 214,
    productId: 7,
    userName: "Ursla Whelan",
    userHandle: "@urslawhelan",
    rating: 2,
    summary: "Colour was way off",
    date: "2025-08-23",
    time: "11:59:39",
    verified: false,
    images: [],
    description: "The colour I received looks nothing like the photos. What should have been a rich tone is actually quite dull and washed out. The material is also thinner than it appeared. Won't be keeping this.",
    helpful: ["user1_id", "user2_id", "user3_id", "user4_id", "user5_id"]
  },
  {
    id: 215,
    productId: 7,
    userName: "Will Caffrey",
    userHandle: "@willcaffrey",
    rating: 4,
    summary: "Love it, minor fit issue",
    date: "2023-05-18",
    time: "20:24:18",
    verified: false,
    images: [],
    description: "Beautiful quality and really flattering on. The only thing is the arms are slightly tight if you have broader shoulders like me. I sized up and it fits much better. The fabric is luxurious and the colour is lovely.",
    helpful: ["user1_id", "user2_id"]
  },
  {
    id: 216,
    productId: 7,
    userName: "Yvonne Lennon",
    userHandle: "@yvonnelennon",
    rating: 2,
    summary: "Pilled after first wash",
    date: "2025-11-06",
    time: "10:08:48",
    verified: true,
    images: [],
    description: "Was really looking forward to wearing this but it pilled all over after just one gentle wash. The quality doesn't match the price at all. The fit was also larger than expected. Disappointed.",
    helpful: []
  },
  {
    id: 217,
    productId: 7,
    userName: "Zahra Ali",
    userHandle: "@zahraali",
    rating: 4,
    summary: "Really nice, runs slightly small",
    date: "2024-11-11",
    time: "17:42:22",
    verified: false,
    images: [],
    description: "The quality and design are lovely but I'd recommend sizing up. I normally wear a M and this was quite snug. Exchanged for an L and it's perfect now. Beautiful colour and great fabric.",
    helpful: []
  },
  {
    id: 218,
    productId: 7,
    userName: "Beth Kavanagh",
    userHandle: "@bethkavanagh",
    rating: 3,
    summary: "Expected more for the price",
    date: "2025-09-20",
    time: "12:35:51",
    verified: true,
    images: [],
    description: "It's not bad by any means but it doesn't feel like premium quality. The colour is slightly different from the photos — more muted in real life. It's comfortable though and serves its purpose.",
    helpful: ["user1_id", "user2_id", "user3_id"]
  },
  {
    id: 219,
    productId: 7,
    userName: "Cian Redmond",
    userHandle: "@cianredmond",
    rating: 4,
    summary: "Love it, minor fit issue",
    date: "2026-02-26",
    time: "19:20:22",
    verified: true,
    images: [],
    description: "Beautiful quality and really flattering on. The only thing is the arms are slightly tight if you have broader shoulders like me. I sized up and it fits much better. The fabric is luxurious and the colour is lovely.",
    helpful: ["user1_id", "user2_id", "user3_id"]
  },
  {
    id: 220,
    productId: 7,
    userName: "Dara Maguire",
    userHandle: "@daramaguire",
    rating: 5,
    summary: "Cannot fault this at all",
    date: "2025-02-15",
    time: "09:03:34",
    verified: false,
    images: [],
    description: "One of the nicest pieces I've bought this year. The material feels expensive, the stitching is immaculate and the colour is gorgeous in person. I've washed it three times already and it still looks brand new. Will definitely be buying more.",
    helpful: ["user1_id", "user2_id", "user3_id", "user4_id", "user5_id"]
  },
  {
    id: 221,
    productId: 7,
    userName: "Ellen Treacy",
    userHandle: "@ellentreacy",
    rating: 5,
    summary: "Worth every penny",
    date: "2025-08-24",
    time: "14:11:02",
    verified: false,
    images: [],
    description: "I debated for a while before buying this but I'm so glad I did. It's incredibly soft and drapes beautifully. I've received multiple compliments already. The fit is spot on — I got my usual size and it's perfect.",
    helpful: ["user1_id", "user2_id", "user3_id", "user4_id", "user5_id", "user6_id"]
  },
  {
    id: 222,
    productId: 7,
    userName: "Finn Sheridan",
    userHandle: "@finnsheridan",
    rating: 5,
    summary: "Cannot fault this at all",
    date: "2026-01-05",
    time: "19:08:48",
    verified: false,
    images: [],
    description: "One of the nicest pieces I've bought this year. The material feels expensive, the stitching is immaculate and the colour is gorgeous in person. I've washed it three times already and it still looks brand new. Will definitely be buying more.",
    helpful: ["user1_id", "user2_id", "user3_id", "user4_id", "user5_id"]
  },
  {
    id: 223,
    productId: 9,
    userName: "Grace Mahon",
    userHandle: "@gracemahon",
    rating: 3,
    summary: "Expected more for the price",
    date: "2023-05-02",
    time: "21:08:30",
    verified: true,
    images: [],
    description: "It's not bad by any means but it doesn't feel like premium quality. The colour is slightly different from the photos — more muted in real life. It's comfortable though and serves its purpose.",
    helpful: ["user1_id", "user2_id", "user3_id", "user4_id", "user5_id", "user6_id", "user7_id"]
  },
  {
    id: 224,
    productId: 9,
    userName: "Hugh Condon",
    userHandle: "@hughcondon",
    rating: 5,
    summary: "Worth every penny",
    date: "2024-09-02",
    time: "18:26:23",
    verified: false,
    images: [],
    description: "I debated for a while before buying this but I'm so glad I did. It's incredibly soft and drapes beautifully. I've received multiple compliments already. The fit is spot on — I got my usual size and it's perfect.",
    helpful: ["user1_id", "user2_id", "user3_id", "user4_id", "user5_id", "user6_id", "user7_id", "user8_id", "user9_id"]
  },
  {
    id: 225,
    productId: 9,
    userName: "Isobel Feeney",
    userHandle: "@isobelfeeney",
    rating: 4,
    summary: "Lovely quality for the price",
    date: "2025-03-10",
    time: "19:04:46",
    verified: false,
    images: [],
    description: "Impressed with how well this is made. The seams are neat, the fabric is substantial and the fit is flattering. It does attract a bit of lint which is annoying but otherwise a great purchase.",
    helpful: ["user1_id"]
  },
  {
    id: 226,
    productId: 9,
    userName: "Jack Moriarty",
    userHandle: "@jackmoriarty",
    rating: 4,
    summary: "Love it, minor fit issue",
    date: "2024-01-17",
    time: "20:13:45",
    verified: true,
    images: [],
    description: "Beautiful quality and really flattering on. The only thing is the arms are slightly tight if you have broader shoulders like me. I sized up and it fits much better. The fabric is luxurious and the colour is lovely.",
    helpful: []
  },
  {
    id: 227,
    productId: 9,
    userName: "Kate Leahy",
    userHandle: "@kateleahy",
    rating: 4,
    summary: "Really nice, runs slightly small",
    date: "2023-04-18",
    time: "14:55:56",
    verified: true,
    images: [],
    description: "The quality and design are lovely but I'd recommend sizing up. I normally wear a M and this was quite snug. Exchanged for an L and it's perfect now. Beautiful colour and great fabric.",
    helpful: ["user1_id", "user2_id", "user3_id", "user4_id"]
  },
  {
    id: 228,
    productId: 9,
    userName: "Luke Stapleton",
    userHandle: "@lukestapleton",
    rating: 3,
    summary: "Nice but not amazing",
    date: "2024-02-20",
    time: "16:19:28",
    verified: true,
    images: [],
    description: "It's a decent piece for the price but I wouldn't say it blew me away. The fabric is okay — not as plush as I'd hoped from the description. The fit is fine and it looks presentable enough.",
    helpful: ["user1_id", "user2_id"]
  },
  {
    id: 229,
    productId: 9,
    userName: "Molly Gleeson",
    userHandle: "@mollygleeson",
    rating: 3,
    summary: "Nice but not amazing",
    date: "2025-06-20",
    time: "20:55:47",
    verified: false,
    images: [],
    description: "It's a decent piece for the price but I wouldn't say it blew me away. The fabric is okay — not as plush as I'd hoped from the description. The fit is fine and it looks presentable enough.",
    helpful: ["user1_id", "user2_id", "user3_id", "user4_id", "user5_id"]
  },
  {
    id: 230,
    productId: 12,
    userName: "Noel Hennessy",
    userHandle: "@noelhennessy",
    rating: 3,
    summary: "Runs a bit big",
    date: "2023-11-01",
    time: "09:10:34",
    verified: false,
    images: [],
    description: "I found this quite oversized even in my usual size. The fabric is decent and the design is nice but the fit just isn't right for me. Might work if you like a very relaxed look.",
    helpful: ["user1_id", "user2_id", "user3_id", "user4_id"]
  },
  {
    id: 231,
    productId: 12,
    userName: "Olive Shanahan",
    userHandle: "@oliveshanahan",
    rating: 2,
    summary: "Pilled after first wash",
    date: "2025-02-24",
    time: "12:40:53",
    verified: true,
    images: [],
    description: "Was really looking forward to wearing this but it pilled all over after just one gentle wash. The quality doesn't match the price at all. The fit was also larger than expected. Disappointed.",
    helpful: ["user1_id", "user2_id", "user3_id", "user4_id", "user5_id", "user6_id", "user7_id", "user8_id"]
  },
  {
    id: 232,
    productId: 12,
    userName: "Paul Cotter",
    userHandle: "@paulcotter",
    rating: 4,
    summary: "Love it, minor fit issue",
    date: "2026-02-24",
    time: "18:27:23",
    verified: false,
    images: [],
    description: "Beautiful quality and really flattering on. The only thing is the arms are slightly tight if you have broader shoulders like me. I sized up and it fits much better. The fabric is luxurious and the colour is lovely.",
    helpful: ["user1_id", "user2_id", "user3_id", "user4_id", "user5_id", "user6_id", "user7_id", "user8_id"]
  },
  {
    id: 233,
    productId: 12,
    userName: "Rebecca Flood",
    userHandle: "@rebeccaflood",
    rating: 5,
    summary: "Gorgeous and comfortable",
    date: "2025-12-20",
    time: "13:19:04",
    verified: false,
    images: [],
    description: "Really lovely piece. It's cozy and warm, perfect for autumn layering. The colour is true to the pictures online. Very happy with this purchase — it's become a wardrobe staple.",
    helpful: ["user1_id", "user2_id", "user3_id", "user4_id", "user5_id", "user6_id", "user7_id"]
  },
  {
    id: 234,
    productId: 12,
    userName: "Shane Killeen",
    userHandle: "@shanekilleen",
    rating: 5,
    summary: "Worth every penny",
    date: "2024-02-12",
    time: "13:03:04",
    verified: true,
    images: [],
    description: "I debated for a while before buying this but I'm so glad I did. It's incredibly soft and drapes beautifully. I've received multiple compliments already. The fit is spot on — I got my usual size and it's perfect.",
    helpful: []
  },
  {
    id: 235,
    productId: 12,
    userName: "Tara Mannion",
    userHandle: "@taramannion",
    rating: 4,
    summary: "Really nice, runs slightly small",
    date: "2024-09-24",
    time: "10:13:04",
    verified: false,
    images: [],
    description: "The quality and design are lovely but I'd recommend sizing up. I normally wear a M and this was quite snug. Exchanged for an L and it's perfect now. Beautiful colour and great fabric.",
    helpful: ["user1_id", "user2_id", "user3_id", "user4_id", "user5_id", "user6_id"]
  },
  {
    id: 236,
    productId: 12,
    userName: "Ultan Norris",
    userHandle: "@ultannorris",
    rating: 4,
    summary: "Great addition to my wardrobe",
    date: "2023-08-26",
    time: "10:11:17",
    verified: true,
    images: [],
    description: "Really pleased with this. It's versatile enough to dress up or down and the material is soft and comfortable. The length is perfect for me at 5'5. Knocked off a star as it pills slightly under the arms.",
    helpful: ["user1_id"]
  },
  {
    id: 237,
    productId: 13,
    userName: "Vera Scully",
    userHandle: "@verascully",
    rating: 5,
    summary: "Brilliant quality shirt",
    date: "2024-12-18",
    time: "17:56:24",
    verified: true,
    images: [],
    description: "Really impressed with this. The fabric is thick and well made, the fit is modern without being too tight and it looks great tucked in or out. I'm 6ft and the large fits perfectly. Best shirt I've bought in a long time.",
    helpful: ["user1_id"]
  },
  {
    id: 238,
    productId: 14,
    userName: "Aoibheann Flanagan",
    userHandle: "@aoibheannflanagan",
    rating: 2,
    summary: "Doesn't fit well",
    date: "2024-08-29",
    time: "08:35:22",
    verified: false,
    images: [],
    description: "The sizing is all over the place. I tried my usual size and it's tight across the chest but baggy around the waist. The material also creases very easily. Not worth the hassle.",
    helpful: []
  },
  {
    id: 239,
    productId: 14,
    userName: "Colm Tierney",
    userHandle: "@colmtierney",
    rating: 5,
    summary: "Exceptional value",
    date: "2023-11-18",
    time: "11:17:37",
    verified: false,
    images: [],
    description: "For the price, this is incredible. The material feels premium, the buttons are solid and the overall construction is excellent. I've ordered two more in different colours. Highly recommend.",
    helpful: ["user1_id"]
  },
  {
    id: 240,
    productId: 14,
    userName: "Meadhbh Sweeney",
    userHandle: "@meadhbhsweeney",
    rating: 3,
    summary: "Not as expected",
    date: "2024-06-02",
    time: "19:47:58",
    verified: false,
    images: [],
    description: "The colour is slightly different from the pictures — more washed out. The fabric is okay but feels a bit thin for the price. The fit is decent though and it's comfortable enough.",
    helpful: []
  },
  {
    id: 241,
    productId: 14,
    userName: "Ruairi Chambers",
    userHandle: "@ruairichambers",
    rating: 2,
    summary: "Poor stitching",
    date: "2025-07-14",
    time: "20:05:17",
    verified: false,
    images: [],
    description: "Found loose threads on the collar and a poorly sewn button within the first week. The fabric also has an odd smell that took several washes to get rid of. Disappointing at this price point.",
    helpful: ["user1_id", "user2_id", "user3_id", "user4_id", "user5_id"]
  },
  {
    id: 242,
    productId: 14,
    userName: "Cliona Madden",
    userHandle: "@clionamadden",
    rating: 3,
    summary: "Not as expected",
    date: "2025-07-25",
    time: "12:46:06",
    verified: true,
    images: [],
    description: "The colour is slightly different from the pictures — more washed out. The fabric is okay but feels a bit thin for the price. The fit is decent though and it's comfortable enough.",
    helpful: []
  },
  {
    id: 243,
    productId: 15,
    userName: "Diarmuid Foley",
    userHandle: "@diarmuidfoley",
    rating: 4,
    summary: "Good everyday trousers",
    date: "2024-10-22",
    time: "17:40:54",
    verified: true,
    images: [],
    description: "Solid purchase. The fit is comfortable and the material has a nice weight to it. They don't wrinkle too badly which is a plus. Would be 5 stars if the pockets were deeper.",
    helpful: ["user1_id", "user2_id", "user3_id", "user4_id", "user5_id", "user6_id", "user7_id", "user8_id"]
  },
  {
    id: 244,
    productId: 15,
    userName: "Eimear Tobin",
    userHandle: "@eimeartobin",
    rating: 2,
    summary: "Uncomfortable waistband",
    date: "2026-02-28",
    time: "12:39:00",
    verified: false,
    images: [],
    description: "The waistband digs in quite a lot, even after sizing up. The material also doesn't breathe well at all — I was very uncomfortable by the end of the day. Returning these.",
    helpful: ["user1_id", "user2_id", "user3_id", "user4_id", "user5_id", "user6_id"]
  },
  {
    id: 245,
    productId: 15,
    userName: "Fiachra Lowe",
    userHandle: "@fiachralowe",
    rating: 2,
    summary: "Uncomfortable waistband",
    date: "2025-01-27",
    time: "14:01:06",
    verified: false,
    images: [],
    description: "The waistband digs in quite a lot, even after sizing up. The material also doesn't breathe well at all — I was very uncomfortable by the end of the day. Returning these.",
    helpful: ["user1_id"]
  },
  {
    id: 246,
    productId: 15,
    userName: "Ide Callaghan",
    userHandle: "@idecallaghan",
    rating: 2,
    summary: "Uncomfortable waistband",
    date: "2024-03-03",
    time: "16:22:51",
    verified: true,
    images: [],
    description: "The waistband digs in quite a lot, even after sizing up. The material also doesn't breathe well at all — I was very uncomfortable by the end of the day. Returning these.",
    helpful: []
  },
  {
    id: 247,
    productId: 15,
    userName: "Jarlath Hickey",
    userHandle: "@jarlathhickey",
    rating: 4,
    summary: "Nice cut and quality",
    date: "2024-09-12",
    time: "08:15:37",
    verified: false,
    images: [],
    description: "These look great and feel well made. The slim-straight fit works really well. Only minor issue is the waist runs slightly tight — I'd suggest going up a size if you're between sizes.",
    helpful: []
  },
  {
    id: 248,
    productId: 15,
    userName: "Keelin Roche",
    userHandle: "@keelinroche",
    rating: 5,
    summary: "Smart and well made",
    date: "2024-04-22",
    time: "12:40:57",
    verified: true,
    images: [],
    description: "Excellent quality for the price. The waistband is comfortable and the leg cut is modern without being too slim. They press beautifully and look sharp for the office.",
    helpful: ["user1_id", "user2_id", "user3_id", "user4_id", "user5_id"]
  },
  {
    id: 249,
    productId: 15,
    userName: "Lorcan Phelan",
    userHandle: "@lorcanphelan",
    rating: 5,
    summary: "Smart and well made",
    date: "2023-05-27",
    time: "15:53:04",
    verified: true,
    images: [],
    description: "Excellent quality for the price. The waistband is comfortable and the leg cut is modern without being too slim. They press beautifully and look sharp for the office.",
    helpful: []
  },
  {
    id: 250,
    productId: 15,
    userName: "Muirne Dempsey",
    userHandle: "@muirnedempsey",
    rating: 4,
    summary: "Nice cut and quality",
    date: "2025-07-11",
    time: "19:20:45",
    verified: false,
    images: [],
    description: "These look great and feel well made. The slim-straight fit works really well. Only minor issue is the waist runs slightly tight — I'd suggest going up a size if you're between sizes.",
    helpful: ["user1_id", "user2_id", "user3_id", "user4_id", "user5_id"]
  },
  {
    id: 251,
    productId: 15,
    userName: "Naoise Behan",
    userHandle: "@naoisebehan",
    rating: 4,
    summary: "Good everyday trousers",
    date: "2024-03-17",
    time: "10:34:53",
    verified: true,
    images: [],
    description: "Solid purchase. The fit is comfortable and the material has a nice weight to it. They don't wrinkle too badly which is a plus. Would be 5 stars if the pockets were deeper.",
    helpful: []
  },
  {
    id: 252,
    productId: 16,
    userName: "Odhrán Hogan",
    userHandle: "@odhranhogan",
    rating: 1,
    summary: "Button fell off immediately",
    date: "2025-02-04",
    time: "15:54:05",
    verified: true,
    images: [],
    description: "Literally wore this once and a button came off. When I looked closely, all the buttons are barely held on. The fabric is thin and cheap feeling. Complete waste of money, avoid.",
    helpful: []
  },
  {
    id: 253,
    productId: 16,
    userName: "Peig Corcoran",
    userHandle: "@peigcorcoran",
    rating: 5,
    summary: "Brilliant quality shirt",
    date: "2024-02-22",
    time: "21:17:47",
    verified: true,
    images: [],
    description: "Really impressed with this. The fabric is thick and well made, the fit is modern without being too tight and it looks great tucked in or out. I'm 6ft and the large fits perfectly. Best shirt I've bought in a long time.",
    helpful: ["user1_id", "user2_id", "user3_id", "user4_id", "user5_id", "user6_id", "user7_id"]
  },
  {
    id: 254,
    productId: 16,
    userName: "Rian Ennis",
    userHandle: "@rianennis",
    rating: 2,
    summary: "Poor stitching",
    date: "2024-09-12",
    time: "15:39:32",
    verified: false,
    images: [],
    description: "Found loose threads on the collar and a poorly sewn button within the first week. The fabric also has an odd smell that took several washes to get rid of. Disappointing at this price point.",
    helpful: ["user1_id", "user2_id"]
  },
  {
    id: 255,
    productId: 16,
    userName: "Sadhbh Coughlan",
    userHandle: "@sadhbhcoughlan",
    rating: 5,
    summary: "Exceptional value",
    date: "2025-04-27",
    time: "12:54:33",
    verified: true,
    images: [],
    description: "For the price, this is incredible. The material feels premium, the buttons are solid and the overall construction is excellent. I've ordered two more in different colours. Highly recommend.",
    helpful: []
  },
  {
    id: 256,
    productId: 16,
    userName: "Turlough Breen",
    userHandle: "@turloughbreen",
    rating: 4,
    summary: "Gets better with wear",
    date: "2024-02-28",
    time: "12:07:26",
    verified: false,
    images: [],
    description: "The fabric was slightly stiff when new but has softened up nicely after a few washes. The fit is great and it looks smart without being too formal. A reliable everyday option.",
    helpful: []
  },
  {
    id: 257,
    productId: 16,
    userName: "Una Costello",
    userHandle: "@unacostello",
    rating: 4,
    summary: "Good shirt, decent quality",
    date: "2024-02-24",
    time: "20:01:27",
    verified: true,
    images: [],
    description: "Happy with this purchase overall. The fit is true to size and the material is comfortable for all-day wear. The stitching is clean and it presses well. A solid wardrobe addition.",
    helpful: []
  },
  {
    id: 258,
    productId: 16,
    userName: "Blathnaid Kirwan",
    userHandle: "@blathnaidkirwan",
    rating: 4,
    summary: "Comfortable and stylish",
    date: "2024-01-19",
    time: "15:04:49",
    verified: false,
    images: [],
    description: "Really like how this looks and feels. It breathes well which is great for the office. The fit is slightly relaxed which suits me fine. Would buy again for sure.",
    helpful: ["user1_id"]
  },
  {
    id: 259,
    productId: 17,
    userName: "Criostoir Harkin",
    userHandle: "@cristoirharkin",
    rating: 4,
    summary: "Gets better with wear",
    date: "2023-05-19",
    time: "20:04:33",
    verified: false,
    images: [],
    description: "The fabric was slightly stiff when new but has softened up nicely after a few washes. The fit is great and it looks smart without being too formal. A reliable everyday option.",
    helpful: []
  },
  {
    id: 260,
    productId: 17,
    userName: "Doireann Buckley",
    userHandle: "@doireannbuckley",
    rating: 4,
    summary: "Sharp looking shirt",
    date: "2024-03-28",
    time: "11:28:52",
    verified: false,
    images: [],
    description: "Looks great with chinos or jeans. The fabric has a nice texture and the collar sits well. Only small issue is the sleeves could be slightly longer for my arms, but otherwise a solid buy.",
    helpful: ["user1_id", "user2_id", "user3_id"]
  },
  {
    id: 261,
    productId: 18,
    userName: "Eanna Moloney",
    userHandle: "@eannamoloney",
    rating: 5,
    summary: "Brilliant quality shirt",
    date: "2026-02-27",
    time: "12:00:29",
    verified: true,
    images: [],
    description: "Really impressed with this. The fabric is thick and well made, the fit is modern without being too tight and it looks great tucked in or out. I'm 6ft and the large fits perfectly. Best shirt I've bought in a long time.",
    helpful: ["user1_id", "user2_id", "user3_id", "user4_id", "user5_id", "user6_id", "user7_id"]
  },
  {
    id: 262,
    productId: 18,
    userName: "Gormlaith Stack",
    userHandle: "@gormlathstack",
    rating: 4,
    summary: "Comfortable and stylish",
    date: "2023-12-21",
    time: "15:12:29",
    verified: true,
    images: [],
    description: "Really like how this looks and feels. It breathes well which is great for the office. The fit is slightly relaxed which suits me fine. Would buy again for sure.",
    helpful: ["user1_id", "user2_id", "user3_id", "user4_id", "user5_id", "user6_id", "user7_id", "user8_id", "user9_id"]
  },
  {
    id: 263,
    productId: 21,
    userName: "Iarlaith Devlin",
    userHandle: "@iarlathdevlin",
    rating: 4,
    summary: "Nice cut and quality",
    date: "2023-10-02",
    time: "19:40:09",
    verified: false,
    images: [],
    description: "These look great and feel well made. The slim-straight fit works really well. Only minor issue is the waist runs slightly tight — I'd suggest going up a size if you're between sizes.",
    helpful: []
  },
  {
    id: 264,
    productId: 21,
    userName: "Laoise Donovan",
    userHandle: "@laoisedonovan",
    rating: 2,
    summary: "Uncomfortable waistband",
    date: "2023-08-07",
    time: "16:10:04",
    verified: true,
    images: [],
    description: "The waistband digs in quite a lot, even after sizing up. The material also doesn't breathe well at all — I was very uncomfortable by the end of the day. Returning these.",
    helpful: []
  },
  {
    id: 265,
    productId: 21,
    userName: "Malachy Geraghty",
    userHandle: "@malachygeraghty",
    rating: 4,
    summary: "Good everyday trousers",
    date: "2025-07-04",
    time: "12:13:26",
    verified: false,
    images: [],
    description: "Solid purchase. The fit is comfortable and the material has a nice weight to it. They don't wrinkle too badly which is a plus. Would be 5 stars if the pockets were deeper.",
    helpful: ["user1_id", "user2_id", "user3_id"]
  },
  {
    id: 266,
    productId: 21,
    userName: "Neasa Tully",
    userHandle: "@neasatully",
    rating: 4,
    summary: "Good everyday trousers",
    date: "2025-08-18",
    time: "08:38:32",
    verified: false,
    images: [],
    description: "Solid purchase. The fit is comfortable and the material has a nice weight to it. They don't wrinkle too badly which is a plus. Would be 5 stars if the pockets were deeper.",
    helpful: ["user1_id", "user2_id", "user3_id", "user4_id", "user5_id"]
  },
  {
    id: 267,
    productId: 22,
    userName: "Odhran Kelly",
    userHandle: "@odhrankelly",
    rating: 1,
    summary: "Button fell off immediately",
    date: "2024-03-06",
    time: "21:01:19",
    verified: true,
    images: [],
    description: "Literally wore this once and a button came off. When I looked closely, all the buttons are barely held on. The fabric is thin and cheap feeling. Complete waste of money, avoid.",
    helpful: ["user1_id", "user2_id", "user3_id", "user4_id", "user5_id"]
  },
  {
    id: 268,
    productId: 22,
    userName: "Proinnsias Noonan",
    userHandle: "@proinnsiasnonan",
    rating: 4,
    summary: "Good shirt, decent quality",
    date: "2025-09-20",
    time: "18:27:18",
    verified: true,
    images: [],
    description: "Happy with this purchase overall. The fit is true to size and the material is comfortable for all-day wear. The stitching is clean and it presses well. A solid wardrobe addition.",
    helpful: []
  },
  {
    id: 269,
    productId: 22,
    userName: "Rowan McEvoy",
    userHandle: "@rowanmcevoy",
    rating: 4,
    summary: "Comfortable and stylish",
    date: "2023-12-24",
    time: "19:49:52",
    verified: true,
    images: [],
    description: "Really like how this looks and feels. It breathes well which is great for the office. The fit is slightly relaxed which suits me fine. Would buy again for sure.",
    helpful: []
  },
  {
    id: 270,
    productId: 22,
    userName: "Sibeal Crowe",
    userHandle: "@sibealcrowe",
    rating: 2,
    summary: "Doesn't fit well",
    date: "2024-06-27",
    time: "21:46:16",
    verified: true,
    images: [],
    description: "The sizing is all over the place. I tried my usual size and it's tight across the chest but baggy around the waist. The material also creases very easily. Not worth the hassle.",
    helpful: ["user1_id", "user2_id", "user3_id", "user4_id", "user5_id"]
  },
  {
    id: 271,
    productId: 22,
    userName: "Tiernan Fallon",
    userHandle: "@tiernanfallon",
    rating: 4,
    summary: "Good shirt, decent quality",
    date: "2024-03-07",
    time: "09:30:57",
    verified: false,
    images: [],
    description: "Happy with this purchase overall. The fit is true to size and the material is comfortable for all-day wear. The stitching is clean and it presses well. A solid wardrobe addition.",
    helpful: ["user1_id", "user2_id", "user3_id", "user4_id"]
  },
  {
    id: 272,
    productId: 23,
    userName: "Ursla Whelan",
    userHandle: "@urslawhelan",
    rating: 2,
    summary: "Poor stitching",
    date: "2025-12-22",
    time: "09:18:19",
    verified: true,
    images: [],
    description: "Found loose threads on the collar and a poorly sewn button within the first week. The fabric also has an odd smell that took several washes to get rid of. Disappointing at this price point.",
    helpful: ["user1_id", "user2_id", "user3_id"]
  },
  {
    id: 273,
    productId: 23,
    userName: "Will Caffrey",
    userHandle: "@willcaffrey",
    rating: 3,
    summary: "Average enough",
    date: "2024-03-16",
    time: "14:28:11",
    verified: false,
    images: [],
    description: "It's fine. Not amazing, not terrible. The fit is okay but a bit boxy around the waist. The material is decent but wrinkles quite easily. It does the job for casual days but I've had better.",
    helpful: ["user1_id"]
  },
  {
    id: 274,
    productId: 23,
    userName: "Yvonne Lennon",
    userHandle: "@yvonnelennon",
    rating: 5,
    summary: "Exceptional value",
    date: "2025-02-22",
    time: "16:47:36",
    verified: false,
    images: [],
    description: "For the price, this is incredible. The material feels premium, the buttons are solid and the overall construction is excellent. I've ordered two more in different colours. Highly recommend.",
    helpful: ["user1_id", "user2_id", "user3_id", "user4_id", "user5_id", "user6_id", "user7_id", "user8_id"]
  },
  {
    id: 275,
    productId: 25,
    userName: "Zahra Ali",
    userHandle: "@zahraali",
    rating: 4,
    summary: "Good quality for kids",
    date: "2024-05-27",
    time: "13:47:05",
    verified: false,
    images: [],
    description: "Nice piece of clothing. The fabric is durable which is exactly what you need for active boys. The fit is good with a bit of room to grow. The design is nice and my son is happy with it.",
    helpful: []
  },
  {
    id: 276,
    productId: 25,
    userName: "Beth Kavanagh",
    userHandle: "@bethkavanagh",
    rating: 3,
    summary: "It does the job",
    date: "2025-06-25",
    time: "20:46:12",
    verified: false,
    images: [],
    description: "Nothing wrong with it but nothing standout either. The fabric is fine — not the softest but perfectly acceptable. The fit is okay and it washes well. A standard kids' top really.",
    helpful: ["user1_id"]
  },
  {
    id: 277,
    productId: 25,
    userName: "Cian Redmond",
    userHandle: "@cianredmond",
    rating: 5,
    summary: "Will buy more",
    date: "2024-06-27",
    time: "13:19:19",
    verified: false,
    images: [],
    description: "This is his new favourite top. He wears it constantly and it's holding up brilliantly. The material is soft, the design is cool enough that he actually wants to wear it, and the price is fair.",
    helpful: []
  },
  {
    id: 278,
    productId: 25,
    userName: "Dara Maguire",
    userHandle: "@daramaguire",
    rating: 3,
    summary: "It does the job",
    date: "2025-11-20",
    time: "18:37:31",
    verified: false,
    images: [],
    description: "Nothing wrong with it but nothing standout either. The fabric is fine — not the softest but perfectly acceptable. The fit is okay and it washes well. A standard kids' top really.",
    helpful: ["user1_id", "user2_id", "user3_id", "user4_id", "user5_id", "user6_id", "user7_id"]
  },
  {
    id: 279,
    productId: 25,
    userName: "Ellen Treacy",
    userHandle: "@ellentreacy",
    rating: 4,
    summary: "Happy with the purchase",
    date: "2025-06-04",
    time: "20:28:51",
    verified: true,
    images: [],
    description: "Well made and comfortable. My boy has been wearing it to school and it still looks great. The stitching is solid and the colours haven't faded. Would definitely recommend for other parents.",
    helpful: ["user1_id", "user2_id", "user3_id", "user4_id", "user5_id", "user6_id"]
  },
  {
    id: 280,
    productId: 25,
    userName: "Finn Sheridan",
    userHandle: "@finnsheridan",
    rating: 3,
    summary: "Slightly disappointing",
    date: "2025-10-18",
    time: "10:37:30",
    verified: true,
    images: [],
    description: "Expected better quality for the price. The fabric is thinner than it looks online and the stitching could be neater. My son doesn't mind wearing it though so it's passable.",
    helpful: []
  },
  {
    id: 281,
    productId: 25,
    userName: "Grace Mahon",
    userHandle: "@gracemahon",
    rating: 2,
    summary: "Shrank after washing",
    date: "2025-04-23",
    time: "08:21:29",
    verified: false,
    images: [],
    description: "Washed it according to the label instructions and it shrank noticeably. My son could barely fit into it after one wash. The quality just isn't there. Won't be buying this brand again.",
    helpful: []
  },
  {
    id: 282,
    productId: 25,
    userName: "Hugh Condon",
    userHandle: "@hughcondon",
    rating: 4,
    summary: "Happy with the purchase",
    date: "2025-08-11",
    time: "13:27:19",
    verified: true,
    images: [],
    description: "Well made and comfortable. My boy has been wearing it to school and it still looks great. The stitching is solid and the colours haven't faded. Would definitely recommend for other parents.",
    helpful: []
  },
  {
    id: 283,
    productId: 25,
    userName: "Isobel Feeney",
    userHandle: "@isobelfeeney",
    rating: 4,
    summary: "Decent kids' top",
    date: "2025-11-02",
    time: "14:36:53",
    verified: true,
    images: [],
    description: "Pleased with this overall. The sizing is spot on and the material feels good quality. My son says it's comfortable which is the main thing. One star off because the design is a bit plain.",
    helpful: []
  },
  {
    id: 284,
    productId: 26,
    userName: "Jack Moriarty",
    userHandle: "@jackmoriarty",
    rating: 5,
    summary: "Will buy more",
    date: "2025-02-24",
    time: "11:03:44",
    verified: false,
    images: [],
    description: "This is his new favourite top. He wears it constantly and it's holding up brilliantly. The material is soft, the design is cool enough that he actually wants to wear it, and the price is fair.",
    helpful: []
  },
  {
    id: 285,
    productId: 26,
    userName: "Kate Leahy",
    userHandle: "@kateleahy",
    rating: 3,
    summary: "Slightly disappointing",
    date: "2025-07-13",
    time: "11:37:27",
    verified: true,
    images: [],
    description: "Expected better quality for the price. The fabric is thinner than it looks online and the stitching could be neater. My son doesn't mind wearing it though so it's passable.",
    helpful: []
  },
  {
    id: 286,
    productId: 27,
    userName: "Luke Stapleton",
    userHandle: "@lukestapleton",
    rating: 4,
    summary: "Decent kids' top",
    date: "2023-02-09",
    time: "11:17:48",
    verified: false,
    images: [],
    description: "Pleased with this overall. The sizing is spot on and the material feels good quality. My son says it's comfortable which is the main thing. One star off because the design is a bit plain.",
    helpful: ["user1_id", "user2_id"]
  },
  {
    id: 287,
    productId: 27,
    userName: "Molly Gleeson",
    userHandle: "@mollygleeson",
    rating: 1,
    summary: "Complete waste",
    date: "2023-03-10",
    time: "18:59:52",
    verified: false,
    images: [],
    description: "The stitching came undone on the first day my son wore it. The material is paper thin and cheap feeling. Absolutely not worth the money. Returned immediately.",
    helpful: ["user1_id", "user2_id", "user3_id", "user4_id", "user5_id", "user6_id", "user7_id"]
  },
  {
    id: 288,
    productId: 27,
    userName: "Noel Hennessy",
    userHandle: "@noelhennessy",
    rating: 4,
    summary: "Happy with the purchase",
    date: "2025-08-25",
    time: "17:15:53",
    verified: true,
    images: [],
    description: "Well made and comfortable. My boy has been wearing it to school and it still looks great. The stitching is solid and the colours haven't faded. Would definitely recommend for other parents.",
    helpful: ["user1_id", "user2_id", "user3_id", "user4_id", "user5_id", "user6_id", "user7_id"]
  },
  {
    id: 289,
    productId: 27,
    userName: "Olive Shanahan",
    userHandle: "@oliveshanahan",
    rating: 2,
    summary: "Shrank after washing",
    date: "2023-10-04",
    time: "19:57:05",
    verified: true,
    images: [],
    description: "Washed it according to the label instructions and it shrank noticeably. My son could barely fit into it after one wash. The quality just isn't there. Won't be buying this brand again.",
    helpful: []
  },
  {
    id: 290,
    productId: 27,
    userName: "Paul Cotter",
    userHandle: "@paulcotter",
    rating: 5,
    summary: "Excellent kids' clothing",
    date: "2024-05-02",
    time: "17:40:09",
    verified: true,
    images: [],
    description: "So impressed with this. The quality is far better than what you'd find in most high street shops. My son finds it really comfortable and it fits well — true to the size guide. Highly recommend.",
    helpful: []
  },
  {
    id: 291,
    productId: 27,
    userName: "Rebecca Flood",
    userHandle: "@rebeccaflood",
    rating: 3,
    summary: "Slightly disappointing",
    date: "2024-04-16",
    time: "11:21:18",
    verified: false,
    images: [],
    description: "Expected better quality for the price. The fabric is thinner than it looks online and the stitching could be neater. My son doesn't mind wearing it though so it's passable.",
    helpful: ["user1_id", "user2_id", "user3_id", "user4_id"]
  },
  {
    id: 292,
    productId: 27,
    userName: "Shane Killeen",
    userHandle: "@shanekilleen",
    rating: 4,
    summary: "Good quality for kids",
    date: "2023-08-28",
    time: "15:10:34",
    verified: false,
    images: [],
    description: "Nice piece of clothing. The fabric is durable which is exactly what you need for active boys. The fit is good with a bit of room to grow. The design is nice and my son is happy with it.",
    helpful: ["user1_id", "user2_id"]
  },
  {
    id: 293,
    productId: 27,
    userName: "Tara Mannion",
    userHandle: "@taramannion",
    rating: 2,
    summary: "Poor quality material",
    date: "2024-04-09",
    time: "20:22:35",
    verified: false,
    images: [],
    description: "The fabric started pilling after just a few wears and looks tatty already. For an active child this just doesn't hold up at all. Really disappointed with the quality.",
    helpful: ["user1_id", "user2_id", "user3_id", "user4_id", "user5_id", "user6_id", "user7_id"]
  },
  {
    id: 294,
    productId: 27,
    userName: "Ultan Norris",
    userHandle: "@ultannorris",
    rating: 5,
    summary: "Perfect for my son",
    date: "2024-10-29",
    time: "19:14:19",
    verified: false,
    images: [],
    description: "Bought this for my 10 year old and he absolutely loves it. The fabric is soft and comfortable, and it's survived several trips through the washing machine already. The colours are still vibrant. Great quality.",
    helpful: ["user1_id", "user2_id", "user3_id", "user4_id"]
  },
  {
    id: 295,
    productId: 27,
    userName: "Vera Scully",
    userHandle: "@verascully",
    rating: 2,
    summary: "Shrank after washing",
    date: "2023-03-02",
    time: "16:01:46",
    verified: true,
    images: [],
    description: "Washed it according to the label instructions and it shrank noticeably. My son could barely fit into it after one wash. The quality just isn't there. Won't be buying this brand again.",
    helpful: ["user1_id", "user2_id"]
  },
  {
    id: 296,
    productId: 29,
    userName: "Aoibheann Flanagan",
    userHandle: "@aoibheannflanagan",
    rating: 4,
    summary: "Happy with the purchase",
    date: "2023-06-29",
    time: "09:50:13",
    verified: true,
    images: [],
    description: "Well made and comfortable. My boy has been wearing it to school and it still looks great. The stitching is solid and the colours haven't faded. Would definitely recommend for other parents.",
    helpful: ["user1_id", "user2_id", "user3_id", "user4_id", "user5_id", "user6_id", "user7_id", "user8_id"]
  },
  {
    id: 297,
    productId: 29,
    userName: "Colm Tierney",
    userHandle: "@colmtierney",
    rating: 3,
    summary: "Slightly disappointing",
    date: "2024-01-23",
    time: "10:20:19",
    verified: false,
    images: [],
    description: "Expected better quality for the price. The fabric is thinner than it looks online and the stitching could be neater. My son doesn't mind wearing it though so it's passable.",
    helpful: []
  },
  {
    id: 298,
    productId: 29,
    userName: "Meadhbh Sweeney",
    userHandle: "@meadhbhsweeney",
    rating: 4,
    summary: "Decent kids' top",
    date: "2025-01-26",
    time: "09:50:42",
    verified: true,
    images: [],
    description: "Pleased with this overall. The sizing is spot on and the material feels good quality. My son says it's comfortable which is the main thing. One star off because the design is a bit plain.",
    helpful: ["user1_id", "user2_id", "user3_id"]
  },
  {
    id: 299,
    productId: 30,
    userName: "Ruairi Chambers",
    userHandle: "@ruairichambers",
    rating: 4,
    summary: "Good quality for kids",
    date: "2023-03-19",
    time: "18:10:04",
    verified: true,
    images: [],
    description: "Nice piece of clothing. The fabric is durable which is exactly what you need for active boys. The fit is good with a bit of room to grow. The design is nice and my son is happy with it.",
    helpful: []
  },
  {
    id: 300,
    productId: 31,
    userName: "Cliona Madden",
    userHandle: "@clionamadden",
    rating: 2,
    summary: "Poor quality material",
    date: "2025-03-23",
    time: "11:19:45",
    verified: false,
    images: [],
    description: "The fabric started pilling after just a few wears and looks tatty already. For an active child this just doesn't hold up at all. Really disappointed with the quality.",
    helpful: ["user1_id", "user2_id", "user3_id", "user4_id", "user5_id"]
  },
  {
    id: 301,
    productId: 31,
    userName: "Diarmuid Foley",
    userHandle: "@diarmuidfoley",
    rating: 5,
    summary: "Will buy more",
    date: "2023-12-13",
    time: "11:50:14",
    verified: true,
    images: [],
    description: "This is his new favourite top. He wears it constantly and it's holding up brilliantly. The material is soft, the design is cool enough that he actually wants to wear it, and the price is fair.",
    helpful: []
  },
  {
    id: 302,
    productId: 31,
    userName: "Eimear Tobin",
    userHandle: "@eimeartobin",
    rating: 2,
    summary: "Poor quality material",
    date: "2024-09-13",
    time: "11:18:27",
    verified: true,
    images: [],
    description: "The fabric started pilling after just a few wears and looks tatty already. For an active child this just doesn't hold up at all. Really disappointed with the quality.",
    helpful: []
  },
  {
    id: 303,
    productId: 33,
    userName: "Fiachra Lowe",
    userHandle: "@fiachralowe",
    rating: 2,
    summary: "Shrank after washing",
    date: "2025-09-21",
    time: "13:13:14",
    verified: false,
    images: [],
    description: "Washed it according to the label instructions and it shrank noticeably. My son could barely fit into it after one wash. The quality just isn't there. Won't be buying this brand again.",
    helpful: []
  },
  {
    id: 304,
    productId: 33,
    userName: "Ide Callaghan",
    userHandle: "@idecallaghan",
    rating: 2,
    summary: "Poor quality material",
    date: "2023-07-10",
    time: "21:43:25",
    verified: true,
    images: [],
    description: "The fabric started pilling after just a few wears and looks tatty already. For an active child this just doesn't hold up at all. Really disappointed with the quality.",
    helpful: ["user1_id", "user2_id", "user3_id", "user4_id", "user5_id", "user6_id"]
  },
  {
    id: 305,
    productId: 33,
    userName: "Jarlath Hickey",
    userHandle: "@jarlathhickey",
    rating: 5,
    summary: "Will buy more",
    date: "2024-02-04",
    time: "13:23:44",
    verified: true,
    images: [],
    description: "This is his new favourite top. He wears it constantly and it's holding up brilliantly. The material is soft, the design is cool enough that he actually wants to wear it, and the price is fair.",
    helpful: []
  },
  {
    id: 306,
    productId: 33,
    userName: "Keelin Roche",
    userHandle: "@keelinroche",
    rating: 2,
    summary: "Poor quality material",
    date: "2025-06-12",
    time: "21:14:12",
    verified: false,
    images: [],
    description: "The fabric started pilling after just a few wears and looks tatty already. For an active child this just doesn't hold up at all. Really disappointed with the quality.",
    helpful: ["user1_id", "user2_id", "user3_id", "user4_id"]
  },
  {
    id: 307,
    productId: 34,
    userName: "Lorcan Phelan",
    userHandle: "@lorcanphelan",
    rating: 2,
    summary: "Poor quality material",
    date: "2023-08-20",
    time: "19:04:21",
    verified: false,
    images: [],
    description: "The fabric started pilling after just a few wears and looks tatty already. For an active child this just doesn't hold up at all. Really disappointed with the quality.",
    helpful: ["user1_id", "user2_id", "user3_id", "user4_id", "user5_id", "user6_id"]
  },
  {
    id: 308,
    productId: 34,
    userName: "Muirne Dempsey",
    userHandle: "@muirnedempsey",
    rating: 2,
    summary: "Poor quality material",
    date: "2026-01-24",
    time: "17:27:41",
    verified: false,
    images: [],
    description: "The fabric started pilling after just a few wears and looks tatty already. For an active child this just doesn't hold up at all. Really disappointed with the quality.",
    helpful: []
  },
  {
    id: 309,
    productId: 34,
    userName: "Naoise Behan",
    userHandle: "@naoisebehan",
    rating: 5,
    summary: "Perfect for my son",
    date: "2023-07-09",
    time: "17:54:47",
    verified: false,
    images: [],
    description: "Bought this for my 10 year old and he absolutely loves it. The fabric is soft and comfortable, and it's survived several trips through the washing machine already. The colours are still vibrant. Great quality.",
    helpful: []
  },
  {
    id: 310,
    productId: 34,
    userName: "Odhrán Hogan",
    userHandle: "@odhranhogan",
    rating: 2,
    summary: "Poor quality material",
    date: "2025-05-27",
    time: "13:22:29",
    verified: false,
    images: [],
    description: "The fabric started pilling after just a few wears and looks tatty already. For an active child this just doesn't hold up at all. Really disappointed with the quality.",
    helpful: []
  },
  {
    id: 311,
    productId: 35,
    userName: "Peig Corcoran",
    userHandle: "@peigcorcoran",
    rating: 5,
    summary: "Will buy more",
    date: "2024-08-04",
    time: "14:32:39",
    verified: true,
    images: [],
    description: "This is his new favourite top. He wears it constantly and it's holding up brilliantly. The material is soft, the design is cool enough that he actually wants to wear it, and the price is fair.",
    helpful: []
  },
  {
    id: 312,
    productId: 35,
    userName: "Rian Ennis",
    userHandle: "@rianennis",
    rating: 2,
    summary: "Poor quality material",
    date: "2025-08-05",
    time: "09:47:33",
    verified: true,
    images: [],
    description: "The fabric started pilling after just a few wears and looks tatty already. For an active child this just doesn't hold up at all. Really disappointed with the quality.",
    helpful: []
  },
  {
    id: 313,
    productId: 36,
    userName: "Sadhbh Coughlan",
    userHandle: "@sadhbhcoughlan",
    rating: 2,
    summary: "Poor quality material",
    date: "2025-08-10",
    time: "15:07:43",
    verified: true,
    images: [],
    description: "The fabric started pilling after just a few wears and looks tatty already. For an active child this just doesn't hold up at all. Really disappointed with the quality.",
    helpful: []
  },
  {
    id: 314,
    productId: 36,
    userName: "Turlough Breen",
    userHandle: "@turloughbreen",
    rating: 4,
    summary: "Decent kids' top",
    date: "2024-07-27",
    time: "21:02:39",
    verified: false,
    images: [],
    description: "Pleased with this overall. The sizing is spot on and the material feels good quality. My son says it's comfortable which is the main thing. One star off because the design is a bit plain.",
    helpful: []
  },
  {
    id: 315,
    productId: 36,
    userName: "Una Costello",
    userHandle: "@unacostello",
    rating: 4,
    summary: "Happy with the purchase",
    date: "2025-05-14",
    time: "20:46:07",
    verified: true,
    images: [],
    description: "Well made and comfortable. My boy has been wearing it to school and it still looks great. The stitching is solid and the colours haven't faded. Would definitely recommend for other parents.",
    helpful: ["user1_id", "user2_id", "user3_id", "user4_id"]
  },
  {
    id: 316,
    productId: 36,
    userName: "Blathnaid Kirwan",
    userHandle: "@blathnaidkirwan",
    rating: 5,
    summary: "Will buy more",
    date: "2023-09-11",
    time: "21:30:09",
    verified: false,
    images: [],
    description: "This is his new favourite top. He wears it constantly and it's holding up brilliantly. The material is soft, the design is cool enough that he actually wants to wear it, and the price is fair.",
    helpful: ["user1_id", "user2_id", "user3_id", "user4_id"]
  },
  {
    id: 317,
    productId: 36,
    userName: "Criostoir Harkin",
    userHandle: "@cristoirharkin",
    rating: 5,
    summary: "Perfect for my son",
    date: "2025-08-18",
    time: "14:49:20",
    verified: false,
    images: [],
    description: "Bought this for my 10 year old and he absolutely loves it. The fabric is soft and comfortable, and it's survived several trips through the washing machine already. The colours are still vibrant. Great quality.",
    helpful: ["user1_id", "user2_id", "user3_id", "user4_id", "user5_id", "user6_id", "user7_id", "user8_id"]
  },
  {
    id: 318,
    productId: 36,
    userName: "Doireann Buckley",
    userHandle: "@doireannbuckley",
    rating: 3,
    summary: "Slightly disappointing",
    date: "2023-03-13",
    time: "19:26:05",
    verified: false,
    images: [],
    description: "Expected better quality for the price. The fabric is thinner than it looks online and the stitching could be neater. My son doesn't mind wearing it though so it's passable.",
    helpful: ["user1_id", "user2_id", "user3_id", "user4_id", "user5_id", "user6_id", "user7_id", "user8_id", "user9_id"]
  },
  {
    id: 319,
    productId: 36,
    userName: "Eanna Moloney",
    userHandle: "@eannamoloney",
    rating: 3,
    summary: "It does the job",
    date: "2024-03-08",
    time: "12:19:02",
    verified: false,
    images: [],
    description: "Nothing wrong with it but nothing standout either. The fabric is fine — not the softest but perfectly acceptable. The fit is okay and it washes well. A standard kids' top really.",
    helpful: ["user1_id", "user2_id"]
  },
  {
    id: 320,
    productId: 37,
    userName: "Gormlaith Stack",
    userHandle: "@gormlathstack",
    rating: 3,
    summary: "Average quality",
    date: "2026-01-09",
    time: "14:06:05",
    verified: true,
    images: [],
    description: "Not bad but not brilliant either. The fabric is okay and the design is pretty enough. For the price I expected a bit more in terms of material quality. Does the job though.",
    helpful: ["user1_id", "user2_id", "user3_id", "user4_id", "user5_id", "user6_id", "user7_id"]
  },
  {
    id: 321,
    productId: 37,
    userName: "Iarlaith Devlin",
    userHandle: "@iarlathdevlin",
    rating: 5,
    summary: "My daughter loves it!",
    date: "2025-06-18",
    time: "09:16:39",
    verified: true,
    images: [],
    description: "She hasn't stopped wearing this since it arrived. The fabric is soft and comfortable, the colours are beautiful and it survived an energetic birthday party without any damage. Top quality.",
    helpful: []
  },
  {
    id: 322,
    productId: 37,
    userName: "Laoise Donovan",
    userHandle: "@laoisedonovan",
    rating: 5,
    summary: "Absolutely gorgeous",
    date: "2025-06-22",
    time: "18:46:05",
    verified: false,
    images: [],
    description: "This is such a beautiful piece. The details are lovely and the fabric quality is excellent. My daughter got loads of compliments when she wore it. It washes beautifully too. Very happy.",
    helpful: []
  },
  {
    id: 323,
    productId: 37,
    userName: "Malachy Geraghty",
    userHandle: "@malachygeraghty",
    rating: 4,
    summary: "Lovely design and quality",
    date: "2024-11-04",
    time: "10:56:08",
    verified: false,
    images: [],
    description: "Really pretty and well made. My daughter loves the style and it's comfortable enough for all-day wear. The only thing is it runs slightly small so I'd recommend going up a size.",
    helpful: ["user1_id", "user2_id", "user3_id", "user4_id", "user5_id", "user6_id", "user7_id", "user8_id", "user9_id"]
  },
  {
    id: 324,
    productId: 39,
    userName: "Neasa Tully",
    userHandle: "@neasatully",
    rating: 1,
    summary: "Terrible quality",
    date: "2023-06-29",
    time: "21:33:09",
    verified: false,
    images: [],
    description: "A button came off on the first wear and the hem started unravelling after the first wash. For this price I expected much better. The fabric is thin and cheap feeling. Would not recommend at all.",
    helpful: ["user1_id"]
  },
  {
    id: 325,
    productId: 39,
    userName: "Odhran Kelly",
    userHandle: "@odhrankelly",
    rating: 5,
    summary: "Best kids' outfit",
    date: "2023-01-22",
    time: "21:47:41",
    verified: true,
    images: [],
    description: "The quality of this is outstanding. It's well made, comfortable and the design is adorable. My daughter is already asking for another in a different colour. Worth every penny.",
    helpful: []
  },
  {
    id: 326,
    productId: 39,
    userName: "Proinnsias Noonan",
    userHandle: "@proinnsiasnonan",
    rating: 4,
    summary: "Great for special occasions",
    date: "2025-03-20",
    time: "14:00:07",
    verified: true,
    images: [],
    description: "Bought this for a family event and my daughter looked beautiful. The fabric is nice and the stitching is neat. She found it comfortable to wear all evening. Would buy from this range again.",
    helpful: ["user1_id", "user2_id", "user3_id"]
  },
  {
    id: 327,
    productId: 39,
    userName: "Rowan McEvoy",
    userHandle: "@rowanmcevoy",
    rating: 3,
    summary: "It's cute but runs tiny",
    date: "2024-12-20",
    time: "12:10:30",
    verified: false,
    images: [],
    description: "The design is lovely but the sizing is very small. I had to return and get two sizes up which was frustrating. The quality is fine once you get the right size but measure carefully before ordering.",
    helpful: []
  },
  {
    id: 328,
    productId: 39,
    userName: "Sibeal Crowe",
    userHandle: "@sibealcrowe",
    rating: 4,
    summary: "Pretty and practical",
    date: "2023-02-11",
    time: "18:20:25",
    verified: false,
    images: [],
    description: "A nice balance of looking good and being wearable for an active child. The fabric is decent quality and it washes well. My daughter likes wearing it for school and weekends.",
    helpful: ["user1_id"]
  },
  {
    id: 329,
    productId: 41,
    userName: "Tiernan Fallon",
    userHandle: "@tiernanfallon",
    rating: 3,
    summary: "It's cute but runs tiny",
    date: "2023-01-10",
    time: "14:53:09",
    verified: false,
    images: [],
    description: "The design is lovely but the sizing is very small. I had to return and get two sizes up which was frustrating. The quality is fine once you get the right size but measure carefully before ordering.",
    helpful: ["user1_id", "user2_id", "user3_id", "user4_id", "user5_id", "user6_id", "user7_id"]
  },
  {
    id: 330,
    productId: 42,
    userName: "Ursla Whelan",
    userHandle: "@urslawhelan",
    rating: 3,
    summary: "Average quality",
    date: "2026-02-19",
    time: "09:34:23",
    verified: false,
    images: [],
    description: "Not bad but not brilliant either. The fabric is okay and the design is pretty enough. For the price I expected a bit more in terms of material quality. Does the job though.",
    helpful: []
  },
  {
    id: 331,
    productId: 42,
    userName: "Will Caffrey",
    userHandle: "@willcaffrey",
    rating: 5,
    summary: "My daughter loves it!",
    date: "2024-07-27",
    time: "08:59:43",
    verified: false,
    images: [],
    description: "She hasn't stopped wearing this since it arrived. The fabric is soft and comfortable, the colours are beautiful and it survived an energetic birthday party without any damage. Top quality.",
    helpful: ["user1_id", "user2_id", "user3_id", "user4_id", "user5_id", "user6_id"]
  },
  {
    id: 332,
    productId: 42,
    userName: "Yvonne Lennon",
    userHandle: "@yvonnelennon",
    rating: 3,
    summary: "Average quality",
    date: "2024-02-07",
    time: "20:15:01",
    verified: true,
    images: [],
    description: "Not bad but not brilliant either. The fabric is okay and the design is pretty enough. For the price I expected a bit more in terms of material quality. Does the job though.",
    helpful: []
  },
  {
    id: 333,
    productId: 43,
    userName: "Zahra Ali",
    userHandle: "@zahraali",
    rating: 5,
    summary: "My daughter loves it!",
    date: "2023-04-13",
    time: "11:40:23",
    verified: true,
    images: [],
    description: "She hasn't stopped wearing this since it arrived. The fabric is soft and comfortable, the colours are beautiful and it survived an energetic birthday party without any damage. Top quality.",
    helpful: []
  },
];

export default reviews;
